import { ChangeDetectorRef, Component, EventEmitter, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EmployeeTooltipDialogComponent } from '../employee-tooltip-dialog/employee-tooltip-dialog.component';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';
@Component({
  selector: 'app-nine-box',
  templateUrl: './nine-box.component.html',
  styleUrls: ['./nine-box.component.scss'],
})
export class NineBoxComponent implements OnInit {
 

  selectedTypeTabName: any = '';
  selectedTypeTabIndex: any;
  buttonColorName: any;
  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  userId: any;
  loggedInUserName: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  originalData: any;
  showSetupPopup: boolean = false;
  competencyListManagerView: any;
  showImportPopup: boolean = false;
  selectedManagerDashboardId: boolean = false;
  selectedEmployeeDashboardId: any;
  selectedYearForCompetency: any = null;
  pmsYears: any = [];
  
  
  comparisonEmpIdsForSecondLast: any = [];

  selectedEmpYearonYear: any = [];
  selectedYearForGraphTwoHRAdmin: any = null;
  selectedYearForGraphFifthHRAdmin: any = null;
  selectedYearForGraphSix: any = null;
  selectedYearForGraphNineHRAdmin: any = null;
  selectedYearForGraphTenHRAdmin: any = null;
  weightageWiseCompetenciesGraphData: any[] = [];
  graphDataForLineGraph: any[] = [];
  selectedYearForGraphOneHRAdmin: any = null;
  fromYear: any = null;
  toYear: any = null;
  // isPotentialGrid: boolean = false;
  isPotentialGrid: { [key: number]: boolean } = {}; // Object to track row state
  isCheckPerformancePotential: { [key: number]: boolean } = {}; // Object to track row state
  isPotentialGridFormDisabled: boolean = false;
  isPositioning: boolean = false;
  isPositioningFormDisabled: boolean = false;
  getListOfDepartmentsOfComp: any = [];
  departmentsColor: any = [];
  selectDepartmentsColor: any = [];
  selectedYear: any;
  element: any;
  allDepartmentColor:any =[];
  getListOfBandName: any = [];
  checkPotentialGridUrl: any = [];
  errorMessage: any = [];
  errorMediumMessage:any = [];
  errorHighMessage:any = [];
  potentialGridUrl: any;
  isPerformanceUpdateBtn: { [key: number]: boolean } = {}; 
  isPerformanceSaveBtn: { [key: number]: boolean } = {}; 
  isInValidLowMinMaxRange: { [key: number]: boolean } = {}; 
  isInValidMediumMinMaxRange: { [key: number]: boolean } = {}; 
  isInValidHighMinMaxRange: { [key: number]: boolean } = {}; 
  isPositioningEditBtn: { [key: number]: boolean } = {}; 
  isInputPositioning: { [key: number]: boolean } = {}; 
  isPositioningSaveBtn: { [key: number]: boolean } = {}; 
  // isQuestionsSaveBtn: { [key: number]: boolean } = {}; 
  // isQuestionsEditBtn: { [key: number]: boolean } = {}; 
  isPositioningCheckCloseIcon: { [key: number]: boolean } = {}; 
  // isQuestionsCheckCloseIcon: { [key: number]: boolean } = {}; 
 isInputQuestions: boolean[][] = [];
 isQuestionsEditBtn: boolean[][] = [];
 isQuestionsCheckCloseIcon: boolean[][] = [];
 isQuestionsSaveBtn: boolean[][] = [];
 isFreezForHOD: boolean = false;
  isShowMD: any;
  isBandDisabled: boolean = true;   
  isEmployeeDisabled: boolean = true; 

  bandsList: any[] = [];
  nineboxData: any =[];
  performanceDta: any =[];
  dumpReportData: any;
  hoveredEmployees: string[] = [];
  hoveredIndex: number | null = null;

  showPopup: boolean = false;

  popupStyle = {};

  employeetrendAccrossyear: any = [];
 
  arrDumpReport: { [key: string]: any[] } = {}; 
  arrTrendReport: any[] = [];
  selectedDepartments: any =[];
  selectedDepartmentsNineBoxMaster: any =[];
  selectedPerformanceDepartments: any =[];
  allDepartmentsList: any = [];
  arrNineBoxMasterFor9BoxData: any = [];
  arrNineBoxMasterData: any = [];
  employeesData: any = [];
  arrHODByUserList: any = [];
  intHODempCode: any | null;
  arrPerformanceVsPotentialReport: any = [];
  uniqueBands: any[] = []; 
  selectedBands: any[] = [];
  uniqueEmployees: any[] = [];
  selectedPerformanceEmployee: any = [];
  forHodfreezeEmployees: any = [];
  getemployeeDetails: any;

  editedIndividualScoreId: number | null = null;

  editedPerfvsPotential: number | null = null;

  editedScoreId: number | null = null;
  nineBoxesNames: any;
  potentialScoreLength: any;
  performanceScoreLength: any;
 totalWeightage: number[] = [];
  performancePotentialLength: any;
  forDuplicateCheckarrAllQuestions: any =[];
  arrUserIds: any = [];
  loggedInUserDepartment: any | null;
  emptyDepartment: number = 1;
  bandNotFound: boolean = true;
  reloadKey: number = 0;
  constructor(private datePipe: DatePipe, public sharedService: SharedService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog,
    private activatedroute: ActivatedRoute, private toastr: ToastrService,
    private toastController: ToastController,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<EmployeeTooltipDialogComponent>,
    private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService,
  ) {

  }

  ngOnInit() {
    setTimeout(() => {
      console.log("**********parent ngOnint");
    }, 1000);
  
    
    this.cdRef.detectChanges();
    
    
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');

    this.loggedInUserDepartment = sessionStorage.getItem('department');

    
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }


    this.dataRefreshService.refreshNeeded$.subscribe(() => {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd && event.url.includes('/home/hrportal/nineBox')) {
          
          this.fetchKpiScore();
        }
        // console.log("**********************ONINIT")
        // this.fetchKpiScore();
      });});

    if (this.loggedInUserRole == "Super Admin" || this.loggedInUserRole == "Admin" || this.loggedInUserRole == "HR Admin") {
      this.emptyDepartment = 1;
      
    }else{
      if(this.loggedInUserDepartment == 'null' ){
          this.emptyDepartment = 0;
      }
    }
    
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    // this.isShowMD = this.loggedInUserRoles.some((role: any) => role.name === 'MD');
    this.intHODempCode = sessionStorage.getItem('empCode');

    if (this.loggedInUserRoles?.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i]?.displayName == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
      
    }
   

    
    this.getpmsyearlist();
    this.dataRefreshService.refreshNeeded$.subscribe(() => {
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd && event.url.includes('/home/hrportal/nineBox')) {
          this.selectedTypeTabIndex = 0;
          this.fetchKpiScore();
        }
        
      });});
  }



   openDialog(message: string, buttonText: string = 'OK', buttonColor: string = 'red', showSuccessIcon: boolean = false, showSuccessMessage: boolean = false, showCloseIcon: boolean = false) {
      return this.dialog.open(ConfirmationPopupComponent, {
        disableClose: false,
        height: '25%',
        width: '30%',
        data: {
          msg: message,
          btn2: buttonText,
          btn2BgColor: buttonColor,
          showSuccessIcon: showSuccessIcon,
          showSuccessMessage: showSuccessMessage,
          showCloseIcon: showCloseIcon
        }
      });
    }


    tabTypeChanged(event: MatTabChangeEvent) {
      this.selectedTypeTabName = event.tab.textLabel;
      this.selectedTypeTabIndex = event?.index;
    }
  
 
  selectedTypeTabIndexForReport:any;
  selectedTypeTabNameForReport:any='dumpReport';

    tabTypeChangedForReport(event: MatTabChangeEvent) {
    this.selectedTypeTabNameForReport = event.tab.textLabel;
      this.selectedTypeTabIndexForReport = event?.index;
    }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/nineBox', { operation: operation }]);
    console.log("--onClickSetup----")
    this.getAllQuestions();
  }

  
  onClickback() {
    this.router.navigateByUrl('/home/hrportal/nineBox?refresh=' + new Date().getTime());
  }
  
  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
 
      if (params?.operation === 'Setup') {
        if (this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
          || this.loggedInUserRole === 'PHI Admin' || this.loggedInUserRole === 'MD') {
          this.showSetupPopup = true;
        }
      }
    });
  }


  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);
      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
      this.setSelectedYear(yearValue);
    });
  }


  setSelectedYear(yearValue: string): void {
    const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
    if (selectedYearObj) {
      this.selectedYear = this.selectedYearForCompetency = selectedYearObj?.year;
      var test = this.selectedYearForCompetency?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];
      this.defaultCallFunctionsList();
      [this.fromYear, this.toYear] = selectedYearObj?.year.split('-');
    }
  }


  defaultCallFunctionsList() {
      if(this.loggedInUserRole == "HOD"){
        this.getfreezeEmployees();
      }
      this.getDepartmentsByCompany(); 
      this.getBandsByCompany();   
      this.getPerfPotential();   
      this.getPerfPerformance();   
      this.getPositioningList();   

      // -------------------------
      this.getDepartmentList();
      this.getDepartmentData();
      this.fetchHODByUserList();
      this.loadDataFromStorage();
      this.recalculateTotalWeightage();
      if (this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD") {
        this.getAllQuestionsForReport();
      } 
     
  }


  // ----------------For update the KPI Score-----------------

  fetchKpiScore() {
    this.pmsYears.forEach((results: any) => {
      let years = results?.year;
      let arrYear = years?.split('-');

      if (arrYear?.length !== 2) {
        console.error('Invalid year format:', years);
        return;
      }

      const apiUrl = `${this.config.getAllEmployeeDumpReports}/${this.loggedInCompanyFiscalyear}/${years}/${this.loggedInUserCompanyID}`;

      this.httpService.callGetService(apiUrl).subscribe({
        next: (response: any) => {
          if (response && response?.data) {
            const arrAllDumpReport = response?.data;

            let userIdsForSuperAdmin = [];
            if (arrAllDumpReport?.length != 0) {
              userIdsForSuperAdmin = arrAllDumpReport?.map((emp: any) => emp.userId);

              let request = {
                "compId": this.loggedInUserCompanyID,
                "fromYear": Number(arrYear[0]),
                "month": [],
                "search": null,
                "toYear": Number(arrYear[1]),
                "userId": userIdsForSuperAdmin.map(String)
              };


              this.httpService.callPostService(this.config.getMonthYTDReport, request).subscribe((data: any) => {
                if (data?.status) {
                  const employeesData = data?.data?.employeeResponse || [];
                  if (employeesData?.length != 0) {

                    employeesData?.forEach((emp: any) => {
                      if (emp.ytd) {
                        const resultUser = arrAllDumpReport?.find((resp: any) => resp?.employeeId == emp?.employeeId);

                        if (resultUser) {
                          let intUserId = resultUser?.userId
                          let kpiScore = emp.ytd;
                          let strYear = arrYear[0] + "-" + arrYear[1];

                          const payload = {
                            userId: parseInt(intUserId),
                            kpiScore: kpiScore,
                            year: strYear
                          };

                          this.httpService.callPutService(`${this.config.updateKpiScore}`, payload).subscribe(
                            (data: any) => {
                              this.dumpreport();  
                              this.getEmployeeTrends();
                              this.loadNineBoxData();
                               this.getPerformanceVsPotential();
                            },
                            (error: any) => {
                              console.error("Error updating HOD score:", error);
                            }
                          );

                        }
                      }

                    });

                  }

                }
              });


            }


          }
        },
        error: (err: any) => {
          console.error("Error fetching data:", err);
        }
      });


    });
  }



  getYearSetupForDumpReport(year:any) {
    this.selectedYear =year;
    this.selectedYearForCompetency = year;
    this.dumpreport();
  }

  fetchPerformancPotenialReport(year:any) {
    this.selectedYear =year;
    this.selectedYearForCompetency = year;
    this.getPerformanceVsPotential()

  }

  getYearSetupForReimbursement(year:any){
    this.selectedYearForCompetency = year;
    this.selectedYear  = year;
    this.getAllBoxbyCompany();
    this.getPerfPotential();
    this.getPerfPerformance();
    this.getPositioningList();
    this.getAllQuestions();
  }
 
   vpApproval(relatedToName: any) {
  
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to ' + relatedToName + '?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let apiUrl= `${this.config.freezeDepartment}`;
        
        const params = {
          department: this.selectDepartname,
          companyId: this.loggedInUserCompanyID,
          isFrozen: true,
          year:this.selectedYearForCompetency,
          fiscalYear:this.loggedInCompanyFiscalyear

        };
        this.httpService.callPostService(apiUrl, params)
        .subscribe({
          next: async (result: any) => {
            this.openDialog('HOD freezed successfully', 'OK', this.buttonColorName, false, false, false);
          },
          error: async (err: any) => {
            this.openDialog(err.error.message, 'OK', 'red', false, false, false);
          }
        });  
      }
    });
  }


  showAsset(event: any) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '260vw'; 
    dialogConfig.panelClass = 'custom-dialog-container';
    dialogConfig.disableClose = false; 
    dialogConfig.data = {
      operation: event ? "Update" : 'Add',
      selectedTab: this.selectedTypeTabName,
      selectedUserID: 345,
      year: this.selectedYearForCompetency,
      fiscal_year: this.loggedInCompanyFiscalyear,
      assetId: event
    };

    
  }
  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/ninebox-log', { moduleName: moduleName, id: 0 }]); 
  }


  assettabaleheader = [
    { label: 'Asset Name', isMandatory: true, sortingName: 'assetName' },
    { label: 'Band', isMandatory: true, sortingName: 'bands' },
    { label: 'Allocating Department', isMandatory: true, sortingName: 'authorityDepartment' },
    { label: 'Autority Name', isMandatory: true, sortingName: 'authorityName' },
    { label: 'Action' },
  ]

  sortOrder: { [key: string]: 'asc' | 'desc' } = {}; 
  onSortAssending(sortKey: any): void {
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
 
  }

  onSortDesending(sortKey: any): void {
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
  }

  onSortDesendingForasset(sortKey: any) {
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
  }

  onSortAssendingForAsset(sortKey: any) {
    this.sortOrder[sortKey] = this.sortOrder[sortKey] === 'asc' ? 'desc' : 'asc';
  }
  // Sort order state

 

  selectedAssetName = '';
  displayedColumns: string[] = ['assetName'];
  employeeColumns: string[] = ['name', 'email'];


 
  displayedgboxColumns: string[] = ['departmentName', 'departmentColor'];

  getDepartmentsByCompany() {
    this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          departmentName: ele,
          departmentColor:'#ffffff'
        }
        this.getListOfDepartmentsOfComp.push(obj);
      });
     
      // this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { itemName: any; }, b: { itemName: any; }) => a.itemName.localeCompare(b.itemName));
      this.getAllBoxbyCompany();
    })
  }


  getAllBoxbyCompany(){
    this.httpService.callGetService(this.config.getAllBoxbyCompanyId + this.loggedInCompanyFiscalyear+"/"+this.selectedYearForCompetency+"/"+this.loggedInUserCompanyID).subscribe((resp: any) => {
      const backendData =resp?.data;
          this.allDepartmentColor = backendData;

          this.departmentsColor = this.getListOfDepartmentsOfComp?.map((elm:any)=>{
            let matchRecord=backendData?.find((record:any)=>record?.departmentName==elm?.departmentName);
            return{
              ...elm,
              id: matchRecord ? matchRecord?.id : elm?.id || null, 
            departmentColor: matchRecord?matchRecord?.departmentColor:'#ffffff',
            }
          });
          
          this.validateDepartmentColors();
      });
    

  }

 
   
  checkDepartmentColor:any = [];
  isSaveDisabled: boolean = true; 

  changeColor(element: any) {

      element.companyId = this.loggedInUserCompanyID;
      element.year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      element.fiscal_year = this.loggedInCompanyFiscalyear;
      element.changedByUserId = this.loggedInUserId;

      // Check if color already exists for another department
      const colorExists = this.checkDepartmentColor?.some(
          (dept:any) => dept?.departmentColor === element?.departmentColor && dept?.departmentName !== element?.departmentName
      );

      if (colorExists) {
          console.log(`Color ${element.departmentColor} is already assigned to another department!`);
          this.showToast(`Color ${element.departmentColor} is already assigned to another department!`, 'danger'); 
          return;
      }

      // Remove duplicates based on departmentName
      this.checkDepartmentColor = this.checkDepartmentColor?.filter(
          (dept:any, index:any, self:any) => index === self.findIndex((t:any) => t?.departmentName === dept?.departmentName)
      );

      // Check if color already exists for another department
      const colorExistsOnDatabase = this.allDepartmentColor?.some(
          (dept:any) => dept?.departmentColor === element?.departmentColor && dept?.departmentName !== element?.departmentName
      );
      if (colorExistsOnDatabase) {
          console.log(`Color ${element.departmentColor} is already assigned to another department!`);

          this.showToast(`Color ${element.departmentColor} is already assigned to another department!`, 'danger');
          return;
      } 
      // Add the new department
      this.checkDepartmentColor?.push(element);
      this.selectDepartmentsColor = this.checkDepartmentColor;
      this.validateDepartmentColors();
  }

  validateDepartmentColors() {
    // Check if any department has missing color
    this.isSaveDisabled = this.departmentsColor?.some((dept: { departmentColor: string; }) => !dept?.departmentColor || dept?.departmentColor === '#ffffff');
}
  openColorPicker(element: any) {
    // Logic to open a color picker or trigger a modal for color selection
    console.log("Open color picker for:", element);
  }
  displayedThirdTableColumns: string[] = ['category', 'low', 'medium', 'high', 'action'];

 
  PerfvsPotentialGrid = [
    { category: 'PMS performance score (approved by manager)', type: 'performance',ppId:'',performanceScoreLowMin:'',performanceScoreLowMax:'',performanceScoreMediumMax:'',performanceScoreHighMax:''  },
    { category: 'Potential score', type: 'Potential',potentialId:'',performanceScoreLowMin:'',performanceScoreLowMax:'',performanceScoreMediumMax:'',performanceScoreHighMax:'' }
  ];

  positions = [
    { positioning: 'Low performance high potential',name: '',positioningId:'' },
    { positioning: 'Medium performance high potential',name: '',positioningId:'' },
    { positioning: 'High performance high potential',name: '',positioningId:'' },
    { positioning: 'Low performance medium potential',name: '',positioningId:'' },
    { positioning: 'Medium performance medium potential',name: '',positioningId:'' },
    { positioning: 'High performance medium potential',name: '',positioningId:'' },
    { positioning: 'Low performance low potential',name: '',positioningId:''  },
    { positioning: 'Medium performance low potential',name: '',positioningId:'' },
    { positioning: 'High performance low potential',name: '',positioningId:'' },
  ];

 
  dataArray = [
    { band: 'option1', question: '', weight: '' },
    // Add initial rows if needed
  ];
    
  // Array to hold multiple tables
  tables: Array<any> = [
    {
      dataArray: [
        { band: '', question: '', weight: '' },
      ],
    },
  ];

  hideShowFlag: boolean = false;

  

  // ----------------------------------------Add Or Update Department Colour------------------------------------------------

  saveNineBox() {
    if (this.isSaveDisabled) {
        this.showToast('Fill all department colors before saving.', 'danger');
        return;
    }

    // 🔹 Single API Call Instead of Multiple Calls
    const payload = {
        companyId: this.loggedInUserCompanyID,
        year: this.selectedYear || this.selectedYearForCompetency,
        fiscal_year: this.loggedInCompanyFiscalyear,
        changedByUserId: this.loggedInUserId,
        departments: this.departmentsColor?.map((dept: any) => ({
            id: dept?.id || null, // Ensure ID is included if present
            departmentName: dept?.departmentName,
            departmentColor: dept?.departmentColor
        }))
    };

    this.httpService.callPostService(`${this.config.addOrUpdateBox}`, payload).subscribe({
        next: async (result: any) => {
            this.getAllBoxbyCompany(); // Refresh Data After Save
            
            const isUpdate = this.departmentsColor?.some((elm: any) => elm.id);
            let message = isUpdate ? 'Department colors updated successfully' : 'Department colors added successfully';

            this.openDialog(message, 'OK', this.buttonColorName, false, false, false);
        },
        error: async (err: any) => {
            this.openDialog(err.error.message, 'OK', 'red', false, false, false);
        }
    });
}
 
    
  // -----------------------------------------Add Or Update Department Colour-----------------------------------------------
 
    //---------------------------Perf vs Potential Grid-----------------------------------------

    onInputChange(event: Event): void {
      const inputElement = event.target as HTMLInputElement;
      const value = inputElement.value;
      // Use a regex to check if the value is a valid number or float
      const isValid = /^[0-9]*\.?[0-9]*$/.test(value);

      if (!isValid) {
        // If the input is not valid, you can clear the input or show an error message
        inputElement.value = value.replace(/[^0-9.]/g, '');
      }
    }
 
    onMaxRangeChangeLowMin(element: any, k: number) {
      const minValue = parseFloat(element?.performanceScoreLowMin);
      const maxValue = parseFloat(element?.performanceScoreLowMax);

      // Check if both values are valid numbers
      if (isNaN(minValue) || isNaN(maxValue)) {
        console.error("Invalid input: performanceScoreLowMin or performanceScoreLowMax is not a valid number.");
        // this.errorMessage[k] = "Please enter valid numbers for both Min and Max values.";
        this.isInValidLowMinMaxRange[k] = true;
        
        if(this.checkPotentialGridUrl?.length == 0){
          this.isPotentialGrid[k] = false;

        }else{
           this.isPotentialGrid[k] = true;
        }
        return; // Exit the function if inputs are invalid
      }

      // Compare the values
      if (maxValue > minValue) {
        this.errorMessage[k] = ""; // Clear error message if valid
        this.isInValidLowMinMaxRange[k] = false;
        if(this.checkPotentialGridUrl?.length == 0){
          this.isPotentialGrid[k] = false;
           this.isPerformanceSaveBtn[k] = false;

        }else{
           this.isPotentialGrid[k] = true;
        }
      } else {
        this.errorMessage[k] = "Max value should be greater than Min value."; // Set error message
        this.isInValidLowMinMaxRange[k] = true;
        this.isPotentialGrid[k] = false;
        this.isPerformanceSaveBtn[k] = true;
      }
    }

    onMaxRangeChangeLowMax(element:any, k: number){
       const minValue = parseFloat(element?.performanceScoreLowMax);
        const maxValue = parseFloat(element?.performanceScoreMediumMax);
        const lowminValue = parseFloat(element?.performanceScoreLowMin);
        
        
        // Check if both values are valid numbers
        if (isNaN(minValue) && isNaN(maxValue) && isNaN(lowminValue)) {
          console.error("Invalid input: performanceScoreLowMax or performanceScoreMediumMax is not a valid number.");
          // this.errorMessage[k] = "Please enter valid numbers for both Min and Max values.";
          this.isInValidLowMinMaxRange[k] = true;
           if(this.checkPotentialGridUrl?.length == 0){
              this.isPotentialGrid[k] = false;

            }else{
              this.isPotentialGrid[k] = true;
            }
          return; // Exit the function if inputs are invalid
        }
        
        
        // Compare the values
        if ((maxValue > minValue) && minValue > lowminValue) {
          
          this.errorMessage[k] = ""; // Clear error message if valid
          this.isInValidLowMinMaxRange[k] = false;
          if(this.checkPotentialGridUrl?.length == 0){
            this.isPotentialGrid[k] = false;
             this.isPerformanceSaveBtn[k] = false;
          }else{
            this.isPotentialGrid[k] = true;
          }
        }else {
          
          this.isPerformanceSaveBtn[k] = false; 
          this.errorMessage[k] = ""; 
          // Set appropriate error message based on the validation failure
          if (maxValue <= minValue) {
            this.errorMessage[k] = "Max value should be greater than Min value."; // Set error message
            this.isPerformanceSaveBtn[k] = true; 
          } else if (lowminValue > minValue) {
            this.errorMessage[k] = "Max value should be greater than Min value."; // Set error message
            this.isPerformanceSaveBtn[k] = true; 
          }
         
          this.isInValidLowMinMaxRange[k] = true;
          this.isPotentialGrid[k] = false;
    
        }
    }

    onMaxRangeChangeMediumMax(element: any, k: number) {
      const minValue = parseFloat(element?.performanceScoreLowMax);
      const maxValue = parseFloat(element?.performanceScoreMediumMax);
      const maxHighValue = parseFloat(element?.performanceScoreHighMax);

      // Check if all values are valid numbers
      if (isNaN(minValue) || isNaN(maxValue) || isNaN(maxHighValue)) {
        console.error("Invalid input: performanceScoreLowMax, performanceScoreMediumMax, or performanceScoreHighMax is not a valid number.");
        
        this.isInValidMediumMinMaxRange[k] = true;
        if(this.checkPotentialGridUrl?.length == 0){
          this.isPotentialGrid[k] = false;

        }else{
           this.isPotentialGrid[k] = true;
        }
        return; // Exit the function if inputs are invalid
      }

      // Compare the values
      if (maxValue > minValue && maxHighValue > maxValue) {
        this.errorMediumMessage[k] = ''
        this.isInValidMediumMinMaxRange[k] = false;
        // this.isPotentialGrid[k] = true;
         if(this.checkPotentialGridUrl?.length == 0){
          this.isPotentialGrid[k] = false;
           this.isPerformanceSaveBtn[k] = false;

        }else{
           this.isPotentialGrid[k] = true;
        }
      } else {
        // Set appropriate error message based on the validation failure
        if (maxValue <= minValue) {
          this.errorMediumMessage[k] = "Medium Max value should be greater than Low Max value.";
        } else if (maxHighValue <= maxValue) {
          this.errorMediumMessage[k] = "High Max value should be greater than Medium Max value.";
        }
        this.isInValidMediumMinMaxRange[k] = true;
        this.isPotentialGrid[k] = false;
         this.isPerformanceSaveBtn[k] = true;
      }
    }
   
    

    onMaxRangeChangeHighMax(element: any, k: number) {
      const minValue = parseFloat(element?.performanceScoreMediumMax);
      const maxValue = parseFloat(element?.performanceScoreHighMax);

      // Check if both values are valid numbers
      if (isNaN(minValue) || isNaN(maxValue)) {
        console.error("Invalid input: performanceScoreLowMax or performanceScoreMediumMax is not a valid number.");
        this.errorHighMessage[k] = "Please enter valid numbers for both Min and Max values.";
        this.isInValidHighMinMaxRange[k] = true;
        this.isPotentialGrid[k] = false;
        return; // Exit the function if inputs are invalid
      }

      // Compare the values
      if (maxValue > minValue) {
        this.errorHighMessage[k] = ""; // Clear error message if valid
        this.isInValidHighMinMaxRange[k] = false;
         if(this.checkPotentialGridUrl?.length == 0){
          // this.isPotentialGrid[k] = false;
          // this.isPerformanceSaveBtn[k] = false;
          this.isCheckPerformancePotential[k] = false;
        }else{
          //  this.isPotentialGrid[k] = true;
           this.isCheckPerformancePotential[k] = false;
        }
      } else {
        this.errorHighMessage[k] = "High Max value should be greater than Medium Max value."; // Set error message
        this.isInValidHighMinMaxRange[k] = true;
        // this.isPotentialGrid[k] = false;
        // this.isPerformanceSaveBtn[k] = true;
        this.isCheckPerformancePotential[k] = true;
      }
    }



    // For Updating 9 box performance
    editPotentialGrid(data:any,index: number){
      
      this.isPotentialGridFormDisabled = true;
      
       var PotentialGridData: any ={};

      PotentialGridData.companyId = this.loggedInUserCompanyID;
      PotentialGridData.year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      PotentialGridData.fiscalYear = this.loggedInCompanyFiscalyear;
      PotentialGridData.changedByUserId = this.loggedInUserId;

      if(data.type == "performance"){
        
        PotentialGridData.performanceCategory       = "Performance Score";
        PotentialGridData.type                      = "performance";
        PotentialGridData.performanceScoreLowMin    = data?.performanceScoreLowMin;
        PotentialGridData.performanceScoreLowMax    = data?.performanceScoreLowMax;
        PotentialGridData.performanceScoreMediumMax = data?.performanceScoreMediumMax;
        PotentialGridData.performanceScoreHighMax   = data?.performanceScoreHighMax;
        PotentialGridData.ppId                      =  data?.ppId;
        this.potentialGridUrl = this.config.addUpdarePerformance;
        
        this.isPerformanceUpdateBtn[index] = true;
        this.isPerformanceSaveBtn[index] = true;
      }else{
        PotentialGridData.potentialCategory         = "Potential Score";
        PotentialGridData.type                      = "potential";
        PotentialGridData.potentialId               = data?.potentialId;
        PotentialGridData.potentialScoreLowMin      = data?.performanceScoreLowMin;
        PotentialGridData.potentialScoreLowMax      = data?.performanceScoreLowMax;
        PotentialGridData.potentialScoreMediumMax   = data?.performanceScoreMediumMax;
        PotentialGridData.potentialScoreHighMax     = data?.performanceScoreHighMax;
        PotentialGridData.potentialId = data?.potentialId; 
        this.potentialGridUrl = this.config.addUpdarePotential;
        this.isPerformanceUpdateBtn[index] = true;
        this.isPerformanceSaveBtn[index] = true;
        this.editedPerfvsPotential = null;
      }
      
      this.httpService.callPostService(`${this.potentialGridUrl}`, PotentialGridData)
      .subscribe({
        next: async (result: any) => {
           this.editedPerfvsPotential = null;

           this.checkPotentialGridUrl = result?.data;
            if(data.type == "performance"){
                let ppId = result?.data?.ppId;
                this.PerfvsPotentialGrid[0].ppId = ppId;
                
                this.openDialog('performance scores updated successfully', 'OK', this.buttonColorName, false, false, false);
            }else{
              let potentialId = result?.data?.potentialId;
              this.PerfvsPotentialGrid[0].potentialId = potentialId;
             
              this.openDialog('potential scores updated successfully', 'OK', this.buttonColorName, false, false, false);
            
            }

        },
        error: async (err: any) => {
          this.openDialog(err.error.message, 'OK','red', false, false, false);
        }
      }); 

    }

    closePotentialGrid(index: number){
      this.editedPerfvsPotential = null;
      // this.isPerformanceUpdateBtn[index] = true;
      // this.isPerformanceSaveBtn[index] = false;
      this.getPerfPotential();
      this.getPerfPerformance();
    }
    // fetch records of Potential Data 
    getPerfPotential(){
      let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;
 
      this.httpService.callGetService(this.config.getAllPotentialScore + fiscal_year+"/"+year+"/"+companyId).subscribe((resp: any) => {
        if(resp.status){

          this.potentialScoreLength = resp?.data?.length; 
          if(resp.data.length > 0){
            this.isPerformanceUpdateBtn[1] = true;
            this.isPerformanceSaveBtn[1] = true;
            let Potential = resp.data[0];
            this.PerfvsPotentialGrid[1].potentialId = Potential?.potentialId;
            this.PerfvsPotentialGrid[1].performanceScoreLowMin = Potential?.potentialScoreLowMin;
            this.PerfvsPotentialGrid[1].performanceScoreLowMax = Potential?.potentialScoreLowMax;
            this.PerfvsPotentialGrid[1].performanceScoreMediumMax = Potential?.potentialScoreMediumMax;
            this.PerfvsPotentialGrid[1].performanceScoreHighMax = Potential?.potentialScoreHighMax;
           
          }else{
            this.isPerformanceUpdateBtn[1] = false;
            this.isPerformanceSaveBtn[1] = false;
            this.PerfvsPotentialGrid[1].potentialId = '';
            this.PerfvsPotentialGrid[1].performanceScoreLowMin ='';
            this.PerfvsPotentialGrid[1].performanceScoreLowMax = '';
            this.PerfvsPotentialGrid[1].performanceScoreMediumMax = '';
            this.PerfvsPotentialGrid[1].performanceScoreHighMax ='';
          }
        }
         
      })
    }
    // fetch records of Performance Data
    getPerfPerformance (){
      let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;
      // this.isCheckPerformancePotential[0] = true;
      this.httpService.callGetService(this.config.getAllPerformanceScore + fiscal_year+"/"+year+"/"+companyId).subscribe((resp: any) => {
   
        if(resp.status){
          this.performanceScoreLength = resp?.data?.length; 
          if(resp.data.length > 0){
            this.isPerformanceUpdateBtn[0] = true;
            this.isPerformanceSaveBtn[0] = true;
            let Performance  = resp.data[0];
            this.PerfvsPotentialGrid[0].ppId = Performance.ppId;
            this.PerfvsPotentialGrid[0].performanceScoreLowMin = Performance?.performanceScoreLowMin;
            this.PerfvsPotentialGrid[0].performanceScoreLowMax = Performance?.performanceScoreLowMax;
            this.PerfvsPotentialGrid[0].performanceScoreMediumMax = Performance?.performanceScoreMediumMax;
            this.PerfvsPotentialGrid[0].performanceScoreHighMax = Performance?.performanceScoreHighMax;
            

          }else{
            this.isPerformanceUpdateBtn[0] = false;
            this.isPerformanceSaveBtn[0] = false;
            let Performance  = resp.data[0];
            this.PerfvsPotentialGrid[0].ppId = '';
            this.PerfvsPotentialGrid[0].performanceScoreLowMin ='';
            this.PerfvsPotentialGrid[0].performanceScoreLowMax = '';
            this.PerfvsPotentialGrid[0].performanceScoreMediumMax ='';
            this.PerfvsPotentialGrid[0].performanceScoreHighMax = '';
            
          }
        }
        
      })
    }

    updatePotentialGrid(data:any, index: number) {
      this.editedPerfvsPotential = index;
      this.isPerformanceUpdateBtn[index] = false;
    }
       // For add 9 box performance
    // savePotentialGrid(data:any, index: number) {
      
    //   // this.isPotentialGrid = false;
    //   const LowminValue = parseFloat(data.performanceScoreLowMin);
    //   const LowmaxValue = parseFloat(data.performanceScoreLowMax);
    //   const MediumminValue = parseFloat(data.performanceScoreMediumMax);
    //   const maxHighValue = parseFloat(data.performanceScoreHighMax);

    //     // Check if all values are valid numbers
    //   if (isNaN(LowminValue) || isNaN(LowmaxValue) || isNaN(MediumminValue) || isNaN(maxHighValue)) {
    //     console.error("Invalid input: performanceScoreLowMax, performanceScoreMediumMax, or performanceScoreHighMax is not a valid number.");
    //     // this.openDialog('Please enter valid numbers for Min, Max, and High Max values.', 'OK', 'red', false, false, false);
    //       this.showToast("Please enter valid numbers for Min, Max, and High Max values.", 'danger');
    //     return; // Exit the function if inputs are invalid
    //   }

    
    //   this.isPotentialGridFormDisabled = false;
    //   var PotentialGridData: any ={};
  
    //   PotentialGridData.companyId = this.loggedInUserCompanyID;
    //   PotentialGridData.year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
    //   PotentialGridData.fiscalYear = this.loggedInCompanyFiscalyear;
    //   PotentialGridData.changedByUserId = this.loggedInUserId;

    //   if(data.type == "performance"){
    //     PotentialGridData.performanceCategory       = "Performance Score";
    //     PotentialGridData.type                      = "performance";
    //     PotentialGridData.performanceScoreLowMin    = data.performanceScoreLowMin;
    //     PotentialGridData.performanceScoreLowMax    = data.performanceScoreLowMax;
    //     PotentialGridData.performanceScoreMediumMax = data.performanceScoreMediumMax;
    //     PotentialGridData.performanceScoreHighMax   = data.performanceScoreHighMax;
    //     PotentialGridData.ppId = data.ppId;
    //     this.potentialGridUrl = this.config.addUpdarePerformance;
        
    //     this.isPerformanceUpdateBtn[index] = true;
    //     this.isPerformanceSaveBtn[index] = true;
    //   }else{
    //     PotentialGridData.potentialCategory        = "Potential Score";
    //     PotentialGridData.type                      = "potential";
    //     PotentialGridData.potentialScoreLowMin      = data.performanceScoreLowMin;
    //     PotentialGridData.potentialScoreLowMax      = data.performanceScoreLowMax;
    //     PotentialGridData.potentialScoreMediumMax   = data.performanceScoreMediumMax;
    //     PotentialGridData.potentialScoreHighMax     = data.performanceScoreHighMax;
    //     PotentialGridData.potentialId = data?.potentialId;
    //     this.potentialGridUrl = this.config.addUpdarePotential;
    //     this.isPerformanceUpdateBtn[index] = true;
    //     this.isPerformanceSaveBtn[index] = true;
    //   }
  
    //   this.httpService.callPostService(`${this.potentialGridUrl}`, PotentialGridData)
    //     .subscribe({
    //       next: async (result: any) => {

    //         if(data.type == "performance"){
    //             let ppId = result.data.ppId;
    //             this.PerfvsPotentialGrid[0].ppId = ppId;
            
    //         }else{
    //           let potentialId = result.data.potentialId;
    //           this.PerfvsPotentialGrid[0].potentialId = potentialId;
    //         }
    //         this.openDialog(result.message, 'OK', this.buttonColorName, false, false, false);
    //       },
    //       error: async (err: any) => {
    //         this.openDialog(err.error.message, 'OK', 'red', false, false, false);
    //       }
    //     });  
        
    // }

 

    //---------------------------End Perf vs Potential Grid-----------------------------------------

    // ------------------------------------------9 Boxes Names----------------------------------------
    
        // fetch records of Potential Data 
    getPositioningList(){
      
      let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;

      this.httpService.callGetService(this.config.getAllPositioning + fiscal_year+"/"+year+"/"+companyId).subscribe((resp: any) => {
        if(resp.status){
          const positions = resp?.data;

       this.nineBoxesNames =positions?.length;

            this.positions = this.positions?.map((elm:any)=>{
            let matchRecord=positions?.find((record:any)=>record?.positioning==elm?.positioning);
            
            return{
              ...elm,
              positioningId: matchRecord?matchRecord?.positioningId:null,
               name: matchRecord?matchRecord?.name:null,
            }
          });
  
          
        }
         
      })
    }

 
    onClickIndividualNames(data:any, index: number) {
      this.editedIndividualScoreId = index;
      Object.keys(this.isInputPositioning)?.forEach(key => {
        this.isInputPositioning[+key] = true;
        this.isPositioningEditBtn[+key] = true;
        this.isPositioningCheckCloseIcon[+key] = false;

      });


      this.isPositioningEditBtn[index] = false;
      this.isInputPositioning[index] = false;
      this.isPositioningCheckCloseIcon[index] = true;
    }
    

    onClosePositioning(data:any, index: number) {
       this.getPositioningList();
      this.editedIndividualScoreId = null;
      this.isPositioningEditBtn[index] = true;
        this.isInputPositioning[index] = true;
      this.isPositioningCheckCloseIcon[index] = false;
    }
    
 
    onClickIndividualScoreEdit(data: any, index: number) {
     
      
      if (!data.name) {
        this.showToast('Positioning name is required', 'danger');
        return;
      }
    
      this.onCheckIconView = true;
      this.isFormDisabled = true;
    
      data.companyId = this.loggedInUserCompanyID;
      data.year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      data.fiscalYear = this.loggedInCompanyFiscalyear;
      data.changedByUserId = this.loggedInUserId;
    
      let message = data.positioningId ? 'Positioning updated successfully' : 'Positioning added successfully';
    
      this.httpService.callPostService(`${this.config.addOrUpdatePositioning}`, data)
        .subscribe({
          next: async (result: any) => {
            this.getPositioningList();
            this.openDialog(message, 'OK', this.buttonColorName, false, false, false);
            this.editedIndividualScoreId = null;
          },
          error: async (err: any) => {
            console.log(err);
            
            this.openDialog(err.error.message, 'OK', 'red', false, false, false);
          }
        });
    }
    
 

    // ------------------------------------------End Boxes Names----------------------------------------

    // ---------------------------------------Potential Questionnaire Table------------------------------

    // Save Each Questions
    onClickQuestionsScoreEdit(data:any, index: number, tableIndex: number) {
      
      console.error(data) 
        data.companyId = this.loggedInUserCompanyID;
        data.year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
        data.fiscalYear = this.loggedInCompanyFiscalyear;
        data.userId = this.loggedInUserId;
      
        this.httpService.callPostService(`${this.config.addOrUpdateQuestion}`, data)
        .subscribe({
          next: async (result: any) => {
            this.loadNineBoxData();
            // await this.showToast(result.message, 'success');
             this.openDialog(result.message, 'OK', this.buttonColorName,false, false,false) ;
            this.getAllQuestions();
            if(data?.questionnaireId){
               this.isQuestionsCheckCloseIcon[tableIndex][index] = false;
               this.isQuestionsEditBtn[tableIndex][index] = true;
                this.isInputQuestions = this.arrQuestionsList?.map((table:any) =>
                  table.question?.map(() => true) // Default all inputs as enabled
                );
             }else{
                this.isQuestionsSaveBtn[tableIndex][index] = false;
                this.isQuestionsEditBtn[tableIndex][index] = true;
                this.isInputQuestions[tableIndex][index] = true;
             }  
             this.editedScoreId=null
            // this.getAllQuestions();
          },
          error: async (err: any) => {
             this.openDialog(err.error.message, 'OK', 'red',false, false,false) ;
          }
        });
    }
    
 
    onClickQuestionslNames(data:any, index: number, tableIndex: number) {
      this.editedScoreId=index;
      this.isQuestionsEditBtn[tableIndex][index] = false;
      this.isInputQuestions[tableIndex][index] = false;
      this.isQuestionsCheckCloseIcon[tableIndex][index] = true;
    }
  
    onClosePositioningQuestions(data:any, index: number, tableIndex: number) {
      this.editedScoreId=null;
      this.isQuestionsCheckCloseIcon[tableIndex][index] = false;
      this.isQuestionsEditBtn[tableIndex][index] = true;
      this.isInputQuestions[tableIndex][index] = true;
    }

   
    restrictToNumbers(event: KeyboardEvent) {
      const inputElement = event.target as HTMLInputElement;
      const allowedChars = /[0-9]$/;
    
      // Check if key is not a number or already has a decimal point
      if (!allowedChars.test(event.key)) {
        event.preventDefault();
        return;
      }
    
      // Predict the new value after adding the pressed key
      const newValue = inputElement.value + event.key;
    
      // Ensure the value does not exceed 100
      if (parseInt(newValue, 10) > 100) {
        event.preventDefault();
      }
    }
    

    validateWeightage(tableIndex: number, rowIndex: number) {
      const selectedBand = this.arrQuestionsList[tableIndex];

      // Ensure weightage is always a valid number
      selectedBand.question.forEach((q: any) => {
        q.weightage = q.weightage ? parseFloat(q.weightage) || 0 : 0;
      });

      // Calculate total weightage
      const totalWeightage = selectedBand?.question?.reduce((sum: number, q: any) => sum + q?.weightage, 0);

      if (totalWeightage > 100) {
        this.openDialog("Total weightage cannot exceed 100!", 'OK', 'red', false, false, false);

        this.isQuestionsCheckCloseIcon[tableIndex][rowIndex] = false;
        this.isQuestionsEditBtn[tableIndex][rowIndex] = true;
        this.isInputQuestions[tableIndex][rowIndex] = true;
        this.getAllQuestions();
      }
    }


    addRow(tableIndex: number) {
      const selectedBand = this.arrQuestionsList[tableIndex];

      // Calculate total weightage
      const totalWeightage = selectedBand?.question?.reduce((sum: number, q: any) => sum + (Number(q?.weightage) || 0), 0);

      if (totalWeightage >= 100) {
         this.openDialog("Total weightage cannot exceed 100!", 'OK', 'red',false, false,false) ;
        return;
      }


      // Add new question row
      selectedBand?.question?.push({
        questionnaireId: '', // Random ID
        band: selectedBand?.band,
        changedByUserId: null,
        hodScore: null,
        totalScore: null,
        question: "",
        weightage: "", // Default weightage
        companyId: this.loggedInUserCompanyID,
        year: this.selectedYear ? this.selectedYear : this.selectedYearForCompetency,
        fiscalYear:  this.loggedInCompanyFiscalyear
      });

        this.arrQuestionsList?.forEach((table: any, tableIndex: number) => {
          if (Array.isArray(table?.question)) {
            table?.question?.forEach((row: any, i: number) => {
              if (row?.question.trim() === '') {
                this.isInputQuestions[tableIndex][i] = false;
                this.isQuestionsSaveBtn[tableIndex][i] = true;
              } else {
                this.isInputQuestions[tableIndex][i] = true; // Enable input when question is not empty
              }
            });
          }
        });
 
    }

 

//===================================== setup =======================================================>

weightageErrorMessages: string[] = [];
 
// Define an object to track errors for each row
duplicateErrors: { [key: number]: boolean } = {};

 

checkDuplicateQuestion(row: any, tableIndex: number, Index: number) {
 
  let strQuestion = row?.question;
  let strBand = row?.band;
  
  let companyId = this.loggedInUserCompanyID;
    let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
    let fiscal_year = this.loggedInCompanyFiscalyear;
    
    this.httpService.callGetService(this.config.getAllQuestions + fiscal_year +"/"+year +"/"+companyId).subscribe((resp: any) => {
        const arrAllQuestions =  resp?.data;
         
        this.forDuplicateCheckarrAllQuestions =  this.getListOfBandName?.map((bandItem:any) => {
          let matchedQuestions = arrAllQuestions?.filter((q:any) => q?.band == bandItem?.band);
          return {
            ...bandItem,
            // id: matchedQuestions?matchedQuestions.id:null,
            question: matchedQuestions?matchedQuestions:null,
          } 
        });
                // Filter the list to get the same band
        const arrQuestionsListFiltered = this.forDuplicateCheckarrAllQuestions?.find((item: any) => item?.band === strBand);

        if (arrQuestionsListFiltered) {
          // Check if the question already exists in the selected band
          const isDuplicate = arrQuestionsListFiltered?.question?.some((q: any) => q?.question === strQuestion);
          
          if (isDuplicate) {
            // this.editedScoreId = Index;
            this.duplicateErrors[tableIndex] = true;
          }
        }
    });

    this.duplicateErrors[tableIndex] = false;
 
  // this.editedScoreId = null;
}

 

limitWeightage(row: any, tableIndex: number) {
  if (row.weightage > 100) {
    row.weightage = 100; // Max value ko 100 restrict karna
    return;
  }
  this.calculateTotalWeightage(tableIndex);
}

calculateTotalWeightage(tableIndex: number) {
  if (!this.arrQuestionsList[tableIndex] || !this.arrQuestionsList[tableIndex].question) {
    this.totalWeightage[tableIndex] = 0;
    return;
  }


  
  this.totalWeightage[tableIndex] = this.arrQuestionsList[tableIndex].question
    .map((q: { weightage: any; }) => Number(q?.weightage) || 0) 
    .reduce((sum: any, value: any) => sum + value, 0);
    
  if (this.totalWeightage[tableIndex] !== 100) {
    this.weightageErrorMessages[tableIndex] = 'Total weightage should be 100';
  } else {
    this.weightageErrorMessages[tableIndex] = '';
  }
  this.saveDataToStorage();
}

saveDataToStorage() {
  localStorage.setItem('arrQuestionsList', JSON.stringify(this.arrQuestionsList));
  localStorage.setItem('totalWeightage', JSON.stringify(this.totalWeightage));
}

loadDataFromStorage() {
  const storedQuestions = localStorage.getItem('arrQuestionsList');
  const storedWeightage = localStorage.getItem('totalWeightage');

  if (storedQuestions) {
    this.arrQuestionsList = JSON.parse(storedQuestions);
  }

  if (storedWeightage) {
    this.totalWeightage = JSON.parse(storedWeightage);
  }
}

recalculateTotalWeightage() {
  this.arrQuestionsList.forEach((_:any, index:number) => this.calculateTotalWeightage(index));
}

deleteBand(tableIndex: any) {
      console.warn("deleteReImbursement")
    
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'Do you really want to delete these band Types?',
            btn1: 'Cancel',
            btn2: 'Delete',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false,
          },
        });
    
        dialogRef.afterClosed().subscribe((result) => {
    
          if (result) {
    
            this.loadNineBoxData();
            this.arrQuestionsList = this.arrQuestionsList?.filter((band: any) => band?.band !== tableIndex);
        
          
            this.getListOfBandName = this.getListOfBandName?.filter((band: any) => band?.band !== tableIndex);
          
            this.httpService.callDeleteService(
              `${this.config.deleteBandsninebox + tableIndex}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`
            )
              .subscribe(
                () => {
                
                 const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                    disableClose: true,
                    height: '25%',
                    width: '30%',
                    data: {
                      msg: 'Questions  deleted successfully.',
                      btn2: 'OK',
                      btn2BgColor: this.buttonColorName,
                      showSuccessIcon: true,
                      showSuccessMessage: false,
                      showCloseIcon: false,
                    },
                  });
                  this.getAllQuestions();
                  successdialogRef.afterClosed().subscribe(() => {
                   
                
                    
                  });
                },
                (error: any) => {
                  // Handle error case
                  console.error('Deletion failed:', error);
    
                  // Optional: Show error dialog
                  const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
                    disableClose: true,
                    height: '25%',
                    width: '30%',
                    data: {
                      msg: 'band successfully deleted.',
                      btn2: 'OK',
                      btn2BgColor: this.buttonColorName,
                      showSuccessIcon: true,
                      showSuccessMessage: false,
                      showCloseIcon: false,
                    },
                  });
                
                }
              );
          }
    
    
        });
      }
    
    
    // Add New Band Table
    addNewBand() { 
      
      const newBandName = `Band ${this.arrQuestionsList.length + 1}`;
      
      const bandExistsInList = this.getListOfBandName?.some((band :any) => band?.band === newBandName);

      const bandExistsInUpdatedList = this.arrQuestionsList?.some((band:any) => band?.band === newBandName);

      if (!bandExistsInList) {
        this.showToast("This band does not exist in the available band list!", 'danger');
      } else if (bandExistsInUpdatedList) {
        alert("Band already added!");
      } else {
        this.arrQuestionsList?.push({
          id: newBandName,
          band: newBandName,
          question: []
        });
        console.log(`Added: ${newBandName}`);
      }
    }


    // Get Available Bands
    getAvailableBands(tableIndex: number) {
      const selectedBands = this.tables[tableIndex]?.dataArray?.map((row :any) => row.band) || [];
      return this.getListOfBandName?.filter((option:any) => !selectedBands?.includes(option.id));
    }
    getBandsByCompany() {
      console.log("----getBandsByCompany----")
      this.httpService.callGetService(this.config.getBandsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
        this.getListOfBandName = [];
        data?.data?.forEach((ele: any) => {
          let obj = {
            id: ele,
            band: ele,
            question: '',
            weightage: '',
          }
          this.getListOfBandName?.push(obj);
        });
        this.getListOfBandName = this.getListOfBandName?.sort((a: { band: any; }, b: { band: any; }) => a.band.localeCompare(b.band));
       
        this.getAllQuestions();
      })
    }

    arrQuestionsList:any = [];

    getAllQuestions() {
      console.log("---getAllQuestions---")
      let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;
      
      this.httpService.callGetService(this.config.getAllQuestions + fiscal_year +"/"+year +"/"+companyId).subscribe((resp: any) => {
          const arrAllQuestions =  resp?.data;
          
          
          this.arrQuestionsList =  this.getListOfBandName?.map((bandItem:any) => {
              let matchedQuestions = arrAllQuestions?.filter((q:any) => q?.band == bandItem?.band);
              return {
                ...bandItem,
                // id: matchedQuestions?matchedQuestions.id:null,
                question: matchedQuestions?matchedQuestions:null,
              } 
          });

          this.forDuplicateCheckarrAllQuestions =  this.getListOfBandName?.map((bandItem:any) => {
            let matchedQuestions = arrAllQuestions?.filter((q:any) => q?.band == bandItem?.band);
            return {
              ...bandItem,
              // id: matchedQuestions?matchedQuestions.id:null,
              question: matchedQuestions?matchedQuestions:null,
            } 
        });

          
          //  calculateTotalWeightage
           this.arrQuestionsList?.forEach((item: any, index: number) => {
            this.calculateTotalWeightage(index);
            if (item.question?.length === 0) {
              
            
            } else if (Array.isArray(item.question)) {
              item.question?.forEach((row: any, key: number) => {
              
              });
            }
          });
          
          this.isInputQuestions = this.arrQuestionsList?.map((table:any) =>
            table.question?.map(() => true) // Default all inputs as enabled
          );
          this.isQuestionsEditBtn = this.arrQuestionsList?.map((table:any) =>
            table.question?.map(() => true) // Default all inputs as enabled
          );
          this.isQuestionsCheckCloseIcon  = this.arrQuestionsList?.map((table:any) =>
            table.question?.map(() => false) // Default all inputs as enabled
          );
          this.isQuestionsSaveBtn  = this.arrQuestionsList?.map((table:any) =>
            table.question?.map(() => false) // Default all inputs as enabled
          );


      })
    }


    
  getAllQuestionsForReport() {

    this.httpService.callGetService(this.config.getEmployeeById + this.loggedInUserId).subscribe((data: any) => {
      let loggedInUserBand = data?.data?.band;

      let companyId = this.loggedInUserCompanyID;
      let year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
      let fiscal_year = this.loggedInCompanyFiscalyear;

      this.httpService.callGetService(this.config.getAllQuestions + fiscal_year + "/" + year + "/" + companyId).subscribe((resp: any) => {
        const arrAllQuestions = resp?.data;


        const bandMatched = arrAllQuestions?.filter((ques: any) => ques?.band == loggedInUserBand);
        this.bandNotFound = bandMatched?.length > 0 ? true : false;

      })


    });


  }

    editPositioning(data:any){
      this.isPositioning = true;
      this.isPositioningFormDisabled = true;
      
        data.companyId = this.loggedInUserCompanyID;
        data.year = this.selectedYear ? this.selectedYear : this.selectedYearForCompetency;
        data.fiscalYear = this.loggedInCompanyFiscalyear;
        data.changedByUserId = this.loggedInUserId;
      
        this.httpService.callPostService(`${this.config.addOrUpdateQuestion}`, data)
        .subscribe({
          next: async (result: any) => {
             this.openDialog(result.message, 'OK', this.buttonColorName, false, false, false);
          },
          error: async (err: any) => {
             this.openDialog(err.error.message, 'OK', 'red', false, false, false);
          }
        });  
    }
 

  async showToast(message: string, color: string) {
    const toast = await this.toastController.create({
      message: message,
      duration: 3000,
      color: color,
      position: 'top'
    });
    await toast.present();
  }



  removeRow(index: number) {
    this.dataArray.splice(index, 1);
    this.hideShowFlag = false
  }


  onCheckIconView = false;
  isFormDisabled = false;

// ---------------------------------------------------9 Box Master----------------------------------------------------------
frequencyDeptName: any = [];
selectDepartname:any=[];
  getDepartmentList() {
      var isHod = false
      if(this.loggedInUserRole == 'HOD'){
        isHod = true
      }
      
      this.httpService.callGetService(this.config.getDepartmentList + this.loggedInUserCompanyID).subscribe((result: any) => {
    
        this.frequencyDeptName = [];
        if (Array.isArray(result?.data)) {
          result?.data?.forEach((ele: any) => {
            let obj = {
              id: ele,
              name: ele,
            }
            this.frequencyDeptName?.push(obj);
          });
          this.frequencyDeptName = this.frequencyDeptName?.sort((a: any, b: any) => a.name?.localeCompare(b.name));
          this.selectDepartname = this.frequencyDeptName[0].id; 
          this.loadNineBoxData();
          if(this.loggedInUserRole == 'HOD' || this.loggedInUserRole === 'HR Admin' || this.loggedInUserRole === 'Super Admin'
            || this.loggedInUserRole === 'PHI Admin'){
            this.findNineBoxMasterData();
          }  
          
          this.getPerformanceVsPotential();
        } else {
          console.error('Expected an array, but got:', result.data);
        }
      });
  }
 
  NineBoxMasterDepartmentChange(event:any){
    this.selectDepartname=event;
    this.selectedDepartmentsNineBoxMaster = [];
    const departmentName = {
      id:event,
      name:event
    }
    // console.log(this.arrNineBoxMasterData);
    
    this.selectedDepartmentsNineBoxMaster?.push(departmentName);
    const nineboxData =  this.arrNineBoxMasterData?.filter((item:any)=>item?.department == this?.selectDepartname.trim());
    this.findNineBoxMasterData();

    if(this.loggedInUserRole == "HOD"){
      this.nineboxData = [];
      nineboxData?.map((item:any)=>{
        if(this.arrHODByUserList?.some((hod:any)=>hod?.userId == item?.userId)){
          this.nineboxData?.push(item);
        }
      });
     
    }else{
      this.nineboxData = nineboxData;
    }
    
   
  }
  
  getfreezeEmployees(){
    const apiUrl = `${this.config.getfreezeEmployees}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;
   
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
       
       this.forHodfreezeEmployees = response?.data;
      },
      error: (err: any) => {
        console.error("Error fetching data:", err);
      }
    });
  }

  loadNineBoxData() {
   
    const apiUrl = `${this.config.getemployeeDetails}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;
 
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        if (response) {
         

          const nineboxData = response?.data;
          this.getemployeeDetails = nineboxData;
          nineboxData.forEach((item:any)=>{
            if(this.loggedInUserRole == "HOD"){
              if(this.forHodfreezeEmployees?.some((hod:any)=>hod?.userId == item?.userId)){
                item.freeze = true;
              }else{
                item.freeze = false;
              }
            }else{
              item.freeze = false;
            }  
            
          });

          this.arrNineBoxMasterData =nineboxData;
        
            
          this.nineboxData = nineboxData?.filter((item:any)=>item?.department == this.selectDepartname?.trim());

          console.log(" nineBox Data....", this.nineboxData)
          
          
        } else {
          console.warn("No data received");
        }
      },
      error: (err: any) => {
        console.error("Error fetching data:", err);
      }
    });
  }

  
  trackByFn(index: number, item: any): number {
    return item?.id; 
  }
  
  trackByQuestion(index: number, question: any): number {
    return question?.questionnaireId; 
  }

  // Validate Total Weightage
isWeightageValid(item: any): boolean {
  const totalWeightage = item?.questions?.reduce((sum: number, que: any) => sum + (parseInt(que?.weightage) || 0), 0);
  return totalWeightage === 100;
}

// Check if ALL employees have valid weightage
isAllWeightageValid(): boolean {
  return this.nineboxData?.every((item: any) => this?.isWeightageValid(item));
}



// ==================== Score By HOD ==============================================

  updateHodScore(item: any, question: any) {

  //const updatedScore = parseInt(item.scoreByHod) || 0;  
  question.totalScore = parseInt(question?.hodScore) || '';


    const payload = {
      userId: parseInt(item?.userId),  
      questionnaireId: question?.questionnaireId,
      hodScore: (question?.hodScore) ? parseInt(question?.hodScore) : ''
    };
   
  
    this.httpService.callPutService(`${this.config.updatehodscore}`, payload).subscribe(
      (data: any) => {
    
    if (data) {
      this.loadNineBoxData();
      this.getPerformanceVsPotential();
      this.dumpreport();
      this.getEmployeeTrends();
      // question.totalScore = data.totalScore !== undefined ? data.totalScore : question.totalScore;
      // item.finalScore = data.finalScore !== undefined ? data.finalScore : item.finalScore;
    }

      },
      (error: any) => {
        console.error("Error updating HOD score:", error);
      }
    );
  }
  

  getDashBoardDeptWiseNineBoxMaster() {
    
    this.findNineBoxMasterData();
  }

  getDashBoardDeptWiseonDeSelectNineBoxMaster() {
    this.onDeSelectAllDeptWiseDashboardNineBoxMaster();
  }

  selectAllDeptWiseDashboardNineBoxMaster(event:any) {
    this.selectedDepartmentsNineBoxMaster = event;
    this.findNineBoxMasterData();
  }

  onDeSelectAllDeptWiseDashboardNineBoxMaster() {
    this.selectedDepartmentsNineBoxMaster = [];
    this.findNineBoxMasterData();
  }
  

 findNineBoxMasterData(){
  console.log("-----------findNineBoxMasterData---------------")
  // this.arrNineBoxMasterData 
  let filteredData: any = {}; // Use an object to group employees by category
  let bandData: any = [];
  let employeeData: any = [];

  let filteredData1: any = {}; // Use an object to group employees by category
  let bandData1: any = [];
  let employeeData1: any = [];

 
  if(this.arrNineBoxMasterFor9BoxData.length == 0){
    this.performanceDta = [
      { count: '0', category: 'Low performance & low potential', cssClass: 'enigma' },
      { count: '0', category: 'High performance & high potential', cssClass: 'growth-employee' },
      { count: '0', category: 'High performance & medium potential', cssClass: 'future-leader' },
      { count: '0', category: 'Low performance & medium potential', cssClass: 'effective' },
      { count: '0', category: 'Medium performance & high potential', cssClass: 'core-employee' },
      { count: '0', category: 'Low performance & high potential', cssClass: 'high-impact-performer' },
      { count: '0', category: 'Medium performance & low potential', cssClass: 'under-performer' },
      { count: '0', category: 'Medium performance & medium potential', cssClass: 'dilemma' },
      { count: '0', category: 'High performance & low potential', cssClass: 'trusted-professional' },
    ];
    return;
  }
console.log(this.arrNineBoxMasterFor9BoxData)
  this.arrNineBoxMasterFor9BoxData?.forEach((record: any) => {
    // Ensure the category exists in filteredData (default structure)
    if (!filteredData[record?.category]) {
      filteredData[record?.category] = {
        category: record?.category,
        count: 0,
        employeeDetails: [],
        cssClass: record?.cssClass
      };
    }
      //for default call 
    if (!filteredData1[record?.category]) {
      filteredData1[record?.category] = {
        category: record?.category,
        count: 0,
        employeeDetails: [],  
        cssClass: record?.cssClass
      };
    }


    if (record?.employeeDetails && Array?.isArray(record?.employeeDetails)) {
      record?.employeeDetails?.forEach((employee: any) => {

        //for default call 
        if (!bandData1[employee?.band]) {
          bandData1?.push(employee?.band) ; 
        }
        
        if(!employeeData1[employee]) {
          employeeData1?.push(employee);
        }
        
        filteredData1[record?.category].employeeDetails?.push(employee);
        filteredData1[record?.category].count++; // Increment count

        if (this.selectedDepartmentsNineBoxMaster?.some((dept: any) => dept?.id == employee?.department)) {
          // Push the employee details into the already initialized category
          if (!bandData[employee?.band]) {
            bandData?.push(employee?.band) ; 
          }
          
          if(this.loggedInUserRole == "HOD"){
            if(this.arrHODByUserList.some((hod:any)=>hod?.userId == employee?.userId)){
                  
                if(!employeeData[employee]) {
                  employeeData?.push(employee);
                }
                
                filteredData[record?.category].employeeDetails?.push(employee);
                filteredData[record?.category].count++; // Increment count

            }
           
          }else{
            
            if(!employeeData[employee]) {
              employeeData?.push(employee);
            }
            
            filteredData[record?.category].employeeDetails?.push(employee);
            filteredData[record?.category].count++; // Increment count

          }
         
     
        }
      });
    }
  });
  console.log(this.performanceDta);
   this.performanceDta = Object?.values(filteredData);
   console.log(this.performanceDta);
   
  this.arrPerformanceVsPotentialReport = Object?.values(filteredData1);
  // this.findNineBoxMasterData();
 }


 getYearSetupForNineBox(selectedYear: any) {
  this.selectedYearForCompetency = selectedYear; 
  
  this.getPerformanceVsPotential();
}


  getPerformanceVsPotential() {
    //this.loader.simpleLoader();
    const colorClasses = [
      "enigma", "growth-employee", "future-leader",
      "dilemma", "core-employee", "high-impact-performer",
      "under-performer", "effective", "trusted-professional"
    ];

    let positions = [
      'Low performance high potential',
      'Medium performance high potential',
      'High performance high potential',
      'Low performance medium potential',
      'Medium performance medium potential',
      'High performance medium potential',
      'Low performance low potential',
      'Medium performance low potential',
      'High performance low potential',
    ];
  
    const apiUrl = `${this.config.getAllPerformancePotential}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;
  
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
        
        
        this.performancePotentialLength = response?.data?.length; 
        
      

        if (response && response.data && response?.data?.length > 0) { 
          const arrDashboardData =response?.data;
          arrDashboardData?.forEach((item: any) => {
            // Remove duplicate employees based on userId
            item.employeeDetails = item.employeeDetails?.filter((employee: any, index: any, self: any) =>
              index === self?.findIndex((e: any) => e?.userId === employee.userId)
            );
          });

          arrDashboardData?.sort((a:any, b:any) => {
            return positions?.indexOf(a?.label) - positions?.indexOf(b?.label);
          });
          
          let performanceDta = arrDashboardData?.map((cell: any, index: number) => ({
            ...cell,
            cssClass: colorClasses[index] || "default-cell" // Assigns a class to each cell
          }));
          this.arrNineBoxMasterFor9BoxData = performanceDta;
          console.log("***************getPerformanceVsPotential*************", this.arrNineBoxMasterFor9BoxData )

          this.findNineBoxMasterData();
          if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){ 
            
            this.forReportPerformanceVsPotential();
           
          }
        } else {
          console.error("NO DATA FOUND");
          this.arrNineBoxMasterFor9BoxData =[];
          this.arrPerformanceVsPotentialReport = [];
          this.findNineBoxMasterData();
         
        }
        
        // this.loader.dismissLoader();
        // this.PerformanceVsPotentialReport();
        if(this.loggedInUserRole != "Employee" ){
          this.forReportPerformanceVsPotential();
        }
      },
      error: (err: any) => {
        console.error("Error fetching data:", err);
      
      }
     
    });
    
  }
  
  
  // Function to return color class based on the category
  getCellColors(category: string) {
    const colorMapping: { [key: string]: string } = {
      "Enigma": "#F4D03F",
      "Growth Employee": "#2ECC71",
      "Future Leader": "#27AE60",
      "Dilemma": "#E67E22",
      "Core Employee": "#F39C12",
      "High Impact Performer": "#76D7C4",
      "Under Performer": "#E74C3C",
      "Effective": "#D35400",
      "Trusted Professional": "#F1C40F"
    };
  
    return { backgroundColor: colorMapping[category] || "#D5D8DC" }; // Default grey color
  }
  
  
   
openEmployeeTooltip(cell: any): void {
  
  this.dialog?.open(EmployeeTooltipDialogComponent, {
   
    data: {
      employees: cell?.employeeDetails || [], 
      departmentsColor: this?.departmentsColor || []
    },
    panelClass: 'custom-dialog-container',
    width: '75%',
    
    position: {
      top: '5%',
      left: '20%'
    }

  });
}



// ---------------------------------------------------End 9 Box Master----------------------------------------------------------

// --------------------------------------------------------Report------------------------------------------------------------------------

fetchHODByUserList(){
  let apiUrl = `${this.config.fetchHODByUserList}?companyId=${this.loggedInUserCompanyID}&hodCode=${this.intHODempCode}&yearRange=${this.selectedYearForCompetency}&fiscalType=${this.loggedInCompanyFiscalyear}`;
  this.httpService.callGetService(apiUrl)
    .subscribe((resp: any) => {
      const arrHODByUserList = resp?.data?.data?.filter((emp:any)=>emp?.userId !=this.loggedInUserId);
      this.arrHODByUserList = arrHODByUserList;
      
      arrHODByUserList?.map((emp:any)=>{
        this.arrUserIds?.push(emp?.userId);
      });

      
    })
}

 
 
// selectedDepartments: string[] = []; 

// dropdownSettings: IDropdownSettings = {};
  getDepartmentsList!: any[];
  dropdownSettings = {
    singleSelection: false,  // or true based on your requirement
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
    getDepartmentData() {
      let isHod = false;
      if (this.loggedInUserRole == 'HOD' && !this.isShowMD) {
        isHod = true;
      }

     
      this.httpService.callGetService(this.config.getDepartmentList + this.loggedInUserCompanyID).subscribe((result: any) => {

          if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){ 
            this.getDepartmentsList = [{id:this.loggedInUserDepartment,name:this.loggedInUserDepartment}];
            this.selectedPerformanceDepartments = [{id:this.loggedInUserDepartment,name:this.loggedInUserDepartment}];
            this.selectedDepartments = [{id:this.loggedInUserDepartment,name:this.loggedInUserDepartment}];
          }else{
            this.getDepartmentsList = result?.data?.map((ele: any) => ({
              id: ele, // Assuming `ele` is the department name or ID that serves as both `id` and `name`
              name: ele
            })).sort((a: any, b: any) => a?.name?.localeCompare(b?.name));

            this.selectedPerformanceDepartments?.push(this.getDepartmentsList[0]);
            this.selectedDepartments?.push(this.getDepartmentsList[0]);
          }

          
          this.selectedDepartmentEmployeeTrends?.push(this.getDepartmentsList[0]);
         
          this.selectedDepartmentsNineBoxMaster?.push(this.getDepartmentsList[0]);
          this.allDepartmentsList?.push(this.getDepartmentsList);
          
        
          
          this.dumpreport();
          this.getEmployeeTrends();
          // If your API response has a different structure, make sure to adjust the 'id' and 'name' mappings accordingly.
        });
    }
 


    dumpreport() {
      const apiUrl = `${this.config.getAllEmployeeDumpReports}/${this.loggedInCompanyFiscalyear}/${this.selectedYearForCompetency}/${this.loggedInUserCompanyID}`;
 
      this.httpService.callGetService(apiUrl).subscribe({
        next: (response: any) => {
          if (response && response?.data) {
            const arrAllDumpReport = response?.data;
            
          // Group data by department
          let groupedData = arrAllDumpReport?.reduce((acc: any, item: any) => {
            if (!acc[item?.department]) {
              acc[item?.department] = [];
            }
            acc[item?.department]?.push(item);
            return acc;
          }, {});
          
        
          
        // Filter grouped data without using Object.fromEntries
          let filteredData:any=[];
       
          Object?.entries(groupedData)?.forEach(([key, value]: any) => {
            if (this.selectedDepartments?.some((dept: any) => dept?.id === key)) {
              if (this.loggedInUserRole === "HOD") {
                const filteredValues = value?.filter((data: any) =>
                  this.arrHODByUserList?.some((hod: any) => hod?.userId === data?.userId)
                );
          
                if (filteredValues.length > 0) {
                  filteredData[key] = filteredValues; // Store filtered results
                }
              }else if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
       
                const filteredValues = value?.filter((data: any) =>
                  this.loggedInUserId == data?.userId
                );
       
                if (filteredValues?.length > 0) {
                  filteredData[key] = filteredValues; // Store filtered results
                }
              }else{
                filteredData[key] = value; // Store full data if not HOD
              }
            }
          });
         
        this.groupedData = filteredData;
        this.arrDumpReport = groupedData;
          // Extract department names for looping in HTML
          this.departments = Object?.keys(this.groupedData);
          
          } else {
            console.warn("No data received");
          }
        },
        error: (err: any) => {
          console.error("Error fetching data:", err);
        }
      });
    }


   // For Dump Report 
  getDashBoardDeptWise() {
 
      //Filter grouped data without using Object.fromEntries
      let filteredData: any = {}; // Use an object instead of an array

      Object?.entries(this.arrDumpReport)?.forEach(([key, value]: [string, any]) => {
        if (this.selectedDepartments?.some((dept: any) => dept?.id === key)) {
          if (this.loggedInUserRole === "HOD") {
            const filteredValues = value?.filter((data: any) =>
              this.arrHODByUserList?.some((hod: any) => hod?.userId === data?.userId)
            );
      
            if (filteredValues.length > 0) {
              filteredData[key] = filteredValues; // Store filtered results
            }
          }else if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
            const filteredValues = value?.filter((data: any) =>
              this.loggedInUserId == data?.userId
            );
            if (filteredValues.length > 0) {
              filteredData[key] = filteredValues; // Store filtered results
            }
          } else {
            filteredData[key] = value; // Store full data if not HOD
          }
        }
      });
      
 
      this.groupedData = filteredData;
      this.selectedCountForDumpreportDepartment = this.selectedDepartments.length;
      this.departments = Object?.keys(this.groupedData); 

  }

  getDashBoardDeptWiseonDeSelect(){
   this.selectedCountForDumpreportDepartment = this.selectedDepartments.length;
    this.getDashBoardDeptWise();
  }

  selectAllDeptWiseDashboard() {
    this.selectedCountForDumpreportDepartment = this.selectedDepartments.length;
    // this.groupedData = this.arrDumpReport;
    this.selectedDepartments = this.getDepartmentsList;
 
    this.getDashBoardDeptWise();
  }

  onDeSelectAllDeptWiseDashboard() {
   this.selectedCountForDumpreportDepartment = 0;
    this.departments = [];
    this.groupedData = {};
    // this.selectAllDeptWiseDashboard();
    
  }
 
selectedCountForDumpreportDepartment:number = 0;
selectedperformancesBands: any[] = [];
selectedCountForPerformanceVsPotentialEmployee: any = [];

  updateSelectedCountForDumpreport(){
    this.selectedCountForDumpreportDepartment = this.selectedDepartments?.length;
    this.selectedCountForPerformanceVsPotentialBand = this.selectedperformancesBands?.length;
    this.selectedCountForPerformanceVsPotentialEmployee = this.selectedPerformanceEmployee?.length;
}


// Ensure selectedDepartments contains only department names (strings)
onDepartmentSelect(event: any) {
 
}

 

// ****************Performance vs Potential Report*********************


// For Performance vs Potential
getSelectedPerformanceVsPotential(event:any) { 
  // --------------------- 
 this.selectedPerformanceEmployee = event;
  this.forReportPerformanceVsPotential();

}

getDeSelectedPerformanceVsPotential(){
  
  if(this.selectedPerformanceDepartments.length == 0){
    this.emptyReportPerformanceVsPotential();
  }else{
    this.selectedperformancesBands = [];
    this.selectedPerformanceEmployee = [];
    this.forReportPerformanceVsPotential(); //Performance vs Potential
  }
// this.selectedPerformanceDepartments = [];

}

selectAllPerformanceVsPotential() { 
 
this.selectedPerformanceDepartments = this.allDepartmentsList[0];
this.selectedperformancesBands = [];
this.selectedPerformanceEmployee = [];
this.forReportPerformanceVsPotential();
}

onDeSelectAllPerformanceVsPotential() {
this.selectedPerformanceDepartments = [];
this.selectedPerformanceEmployee = [];
this.selectedperformancesBands = [];
// this.arrPerformanceVsPotential = [];
this.emptyReportPerformanceVsPotential();
}

selectedCountForPerformanceVsPotentialBand:number = 0;
// performance band dropdown



onPerformanceBandSelect(){
  this.selectedCountForPerformanceVsPotentialBand = this.selectedperformancesBands?.length;
  this.forReportPerformanceVsPotential();
}

onperformanceBandDeSelect(){
  this.selectedPerformanceEmployee = [];
  this.selectedCountForPerformanceVsPotentialBand = this.selectedperformancesBands?.length;
  this.forReportPerformanceVsPotential();
}

onSelectAllPerformanceBands(event:any){
  this.selectedCountForPerformanceVsPotentialBand = this.selectedperformancesBands?.length;
  this.selectedperformancesBands = event;

  this.forReportPerformanceVsPotential();
}

onDeSelectAllPerformanceBands(){
  this.selectedCountForPerformanceVsPotentialBand = 0;
  this.selectedperformancesBands = [];
  this.forReportPerformanceVsPotential();
}

arrEmployeesReport:any = [];
arrPerformanceVsPotential:any = [];
forReportPerformanceVsPotential() {
 
console.log("---------forReportPerformanceVsPotential--------")
  // if(this.selectedPerformanceDepartments.length == 0){
  //   this.selectedperformancesBands = [];
  //   this.selectedPerformanceEmployee = [];
  //   return;
  // }
  let filteredData: any = {}; // Use an object to group employees by category
  let bandData: any = [];
  let employeeData: any = [];

  if(this.arrPerformanceVsPotentialReport.length ==0){
    this.selectedPerformanceDepartments = [];
    this.selectedperformancesBands = [];
    this.selectedPerformanceEmployee =[];
    this.arrPerformanceVsPotential = [
      { count: '0', category: 'Low performance & low potential', cssClass: 'enigma' },
      { count: '0', category: 'High performance & high potential', cssClass: 'growth-employee' },
      { count: '0', category: 'High performance & medium potential', cssClass: 'future-leader' },
      { count: '0', category: 'Low performance & medium potential', cssClass: 'effective' },
      { count: '0', category: 'Medium performance & high potential', cssClass: 'core-employee' },
      { count: '0', category: 'Low performance & high potential', cssClass: 'high-impact-performer' },
      { count: '0', category: 'Medium performance & low potential', cssClass: 'under-performer' },
      { count: '0', category: 'Medium performance & medium potential', cssClass: 'dilemma' },
      { count: '0', category: 'High performance & low potential', cssClass: 'trusted-professional' },
    ];
    return;
  }
  
  this.arrPerformanceVsPotentialReport?.forEach((record: any) => {
    // Ensure the category exists in filteredData (default structure)
    if (!filteredData[record?.category]) {
      filteredData[record?.category] = {
        category: record?.category,
        count: 0,
        employeeDetails: [],
        cssClass: record?.cssClass
      };
    }

    if (record?.employeeDetails && Array?.isArray(record?.employeeDetails)) {
      record?.employeeDetails?.forEach((employee: any) => {
        
        if (this.selectedPerformanceDepartments?.some((dept: any) => dept?.id == employee?.department)) {
          
          // Push the employee details into the already initialized category
          if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
          
            if(this.loggedInUserId == employee?.userId){
             
              if (!bandData[employee?.band]) {
                bandData.push(employee?.band);
              }
            
            }
          }else if(this.loggedInUserRole == "HOD"){
            
            if(this.arrHODByUserList?.some((hod:any)=>hod?.userId == employee?.userId)){
              
              if (!bandData[employee?.band]) {
                bandData?.push(employee?.band);
              }
            }
          }else{  
            if (!bandData[employee?.band]) {
              bandData?.push(employee?.band);
            }
          }
         // For Employee dropdown
          if (Array.isArray(this.selectedPerformanceEmployee) && this.selectedPerformanceEmployee?.length > 0) {
            
            if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
              if(this.loggedInUserId == employee?.userId){
                employeeData?.push(employee);
              }
            }else if(this.loggedInUserRole == "HOD"){
              if(this.arrHODByUserList?.some((hod:any)=>hod?.userId == employee?.userId)){
                employeeData?.push(employee);
              }
            }else{
              employeeData?.push(employee); 
            }
            
          
            
            this.selectedPerformanceEmployee?.forEach((emp:any) => {
             
              if(emp?.name == employee?.employeeName){
                   
                  filteredData[record?.category].employeeDetails?.push(employee);
                  filteredData[record?.category].count++; // Increment count
              }
            
            });
          }else if (Array.isArray(this.selectedperformancesBands) && this.selectedperformancesBands?.length > 0) {
 
            
            this.selectedperformancesBands?.forEach((band: { name: string }) => {
              
              if (employee?.band === band?.name) {
                
                employeeData?.push(employee);
                
                if (!filteredData[record?.category]) {
                  filteredData[record?.category] = { employeeDetails: [], count: 0 };
                }
            
                filteredData[record?.category]?.employeeDetails?.push(employee);
                filteredData[record?.category].count++; // Increment count
              }
              
            });
            
           
          }else{
            
            if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
              if(this.loggedInUserId == employee?.userId){
                employeeData?.push(employee);
                filteredData[record?.category].employeeDetails?.push(employee);
                filteredData[record?.category].count++; // Increment count
              }
            }else if(this.loggedInUserRole == "HOD"){
              if(this.arrHODByUserList?.some((hod:any)=>hod?.userId == employee?.userId)){
                employeeData?.push(employee);
                filteredData[record?.category]?.employeeDetails?.push(employee);
                filteredData[record?.category].count++; // Increment count
              }
            }else{
              if (!employeeData[employee]) {
                employeeData?.push(employee);
              }
              filteredData[record?.category]?.employeeDetails?.push(employee);
              filteredData[record?.category].count++; // Increment count
            }
         
           
             
          }  
     
        }
      });
      

    }
  });


 
    this.arrEmployeesReport = employeeData?.map((emp:any, index:any ) => ({
      id: index,
      name: emp?.employeeName
    }));

 
   
      const uniqueBandData = Array.from(new Set(bandData));

      this.bandListForPerformanceVsPotential = uniqueBandData?.map((emp: any, index: number) => ({
        id: index,
        name: emp
      }));
  
      if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
        this.selectedperformancesBands?.push(this.bandListForPerformanceVsPotential[0]);
         
         if(this.arrEmployeesReport?.length > 0){
          this.selectedPerformanceEmployee= [this.arrEmployeesReport[0]];

         }
      }else{
        if(this.arrEmployeesReport?.length > 0){
          // this.selectedperformancesBands=[];
          // this.selectedPerformanceEmployee = [this.arrEmployeesReport[0]];
        }else{
          
          this.selectedPerformanceEmployee = [];  
        }
      } 
    
    
    
 

  this.arrPerformanceVsPotential = Object?.values(filteredData);
  

}


bandListForPerformanceVsPotential: any[] = [];
 
// performance employee dropdown



onPerformanceEmployeeSelect(){
  this.selectedCountForPerformanceVsPotentialEmployee = this.selectedPerformanceEmployee.length;
  this.forReportPerformanceVsPotential();
}   

onPerformanceEmployeeDeSelect(){
this.selectedCountForPerformanceVsPotentialEmployee = this.selectedPerformanceEmployee.length;
this.forReportPerformanceVsPotential();
}

onSelectAllPerformanceEmployees(event:any){
this.selectedCountForPerformanceVsPotentialEmployee = this.selectedPerformanceEmployee.length;
this.selectedPerformanceEmployee = event;
this.forReportPerformanceVsPotential();
}

onDeSelectAllPerformanceEmployees(){
  this.selectedCountForPerformanceVsPotentialEmployee = 0;
  this.forReportPerformanceVsPotential();
} 


emptyReportPerformanceVsPotential(){
  
  
  let filteredData: any = {}; // Use an object to group employees by category
  let bandData: any = [];
  let employeeData: any = [];
  
  this.arrPerformanceVsPotentialReport.forEach((record: any) => {
    // Ensure the category exists in filteredData (default structure)
    if (!filteredData[record?.category]) {
      filteredData[record?.category] = {
        category: record?.category,
        count: 0,
        employeeDetails: [],
        cssClass: record?.cssClass
      };
    }
 
  });
 
    this.arrEmployeesReport  =[]
 
    this.bandListForPerformanceVsPotential  =[];
    this.selectedPerformanceEmployee = [];
    this.selectedperformancesBands = [];
    this.arrPerformanceVsPotential = Object?.values(filteredData);
  

}




 

// ***********************************


  // ****************Employee trends Across Report*********************


// Employee List
currentEmployeeList: any[] = [];
selectedEmployees: any[] = [];

  getEmployeeTrends() {
    const apiUrl = `${this.config.employeeTrendsReports + this.loggedInUserCompanyID}`;
    
    // this.employeeTrendsScore
    this.httpService.callGetService(apiUrl).subscribe({
      next: (response: any) => {
    
        if (response && response?.data) {  
          // this.employeetrendAccrossyear = response.data;
        
          this.currentEmployeeList =  response?.data;
    
          let departmentNames = this.selectedDepartmentEmployeeTrends?.map((dept: any) => dept?.name);
  

          let filteredData = this.currentEmployeeList?.filter((employee: any) =>
            departmentNames?.includes(employee.department)
          );
          
          if(this.loggedInUserRole == "HOD"){
            filteredData = filteredData?.filter((employee: any) =>
              this.arrHODByUserList?.some((hod:any)=>hod?.userId == employee?.userId)
            );
            this.employeetrendAccrossyear = filteredData;
          }else if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
            filteredData = filteredData?.filter((employee: any) =>
              this.loggedInUserId == employee?.userId
            );
            this.employeetrendAccrossyear = filteredData;
          }else{
            this.employeetrendAccrossyear = filteredData;
          }

          
          
          console.error(this.employeetrendAccrossyear)
          this.extractBandsAndEmployees(this.employeetrendAccrossyear);
          // this.selectedEmployeeTrends =  this.extractBandsAndEmployees;
          

 
           
        } else {
          console.warn("No trends data received");
          this.employeetrendAccrossyear = [];
        }
      },
      error: (err: any) => {
        console.error("Error fetching data:", err);
      }
    });
  }


//departmentmentwise  filter

selectedDepartmentEmployeeTrends:any=[];


getSelectededEmployeeTrends() { 
  this.trendFilterData();
  }

getDeSelectedEMployeeTrends(){
  
  // this.selectedDepartmentEmployeeTrends = [];
  this.selectedtrendsBands = [];
  this.selectedEmployeeTrends = [];
  this.trendFilterData();
}
selectAllEmployeeTrends(event:any) {
  this.selectedDepartmentEmployeeTrends = event;
  
  
  this.trendFilterData();
 }

onDeSelectAllEmployeeTrends() {
  this.selectedDepartmentEmployeeTrends = [];
  this.selectedtrendsBands = [];
  this.selectedEmployeeTrends = [];
  this.trendFilterData();

}


trendFilterData() {

  let departmentNames = this.selectedDepartmentEmployeeTrends?.map((dept: any) => dept?.name);

  let filteredData = this.currentEmployeeList?.filter((employee: any) =>
    departmentNames?.includes(employee?.department)
  );

 
console.warn("-----------------trendFilterData--------")
  this.uniqueBands = [];
  this.uniqueEmployees = [];

  if (this.selectedDepartmentEmployeeTrends?.length === 0) {
    this.employeetrendAccrossyear = [];
    return;  
  }

  if(this.loggedInUserRole == "HOD"){ 
    filteredData = filteredData?.filter((employee: any) =>
      this.arrHODByUserList?.some((hod:any)=>hod?.userId == employee?.userId)
    );
    
  }else if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
    filteredData = filteredData?.filter((employee: any) =>
      this.loggedInUserId == employee?.userId
    );
  }


  this.employeetrendAccrossyear = filteredData;
  



// uniqueEmployees
  // employeetrendAccrossyear
  if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
    this.extractBandsAndEmployees(this.employeetrendAccrossyear);
    this.selectedEmployeeTrends =  this.extractBandsAndEmployees;
    this.selectedtrendsBands = this.extractBandsAndEmployees;
  }else{
    
    this.uniqueEmployees = filteredData?.map((emp, index) => ({
      id: index,
      name: emp.employee
    }));

    let filteredBands = filteredData?.map((emp: any) => emp?.band);
      this.uniqueBands = Array.from(new Set(filteredBands || []))?.sort()?.map((band, index) => ({
        id: index,
        name: band
      }));

  }
  
}



// bandwise filter data
selectedtrendsBands: any= [];


bandDropdownSettings = {
  singleSelection: false, 
  idField: 'id', 
  textField: 'name', 
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 1,
  allowSearchFilter: true, 
};


onBandSelect() {
  this.bandFilterData();

}

onBandDeSelect() {
  this.selectedEmployeeTrends = [];
  this.bandFilterData();
}

onSelectAllBands(event: any) {
  this.selectedtrendsBands = event;
  this.bandFilterData();
}

onDeSelectAllBands() {
 this.selectedtrendsBands = [];
 this.selectedEmployeeTrends = [];
 this.trendFilterData();
}
// Band-wise Filter Function
bandFilterData() {

  if (!Array.isArray(this.selectedtrendsBands)) {
    this.selectedtrendsBands = [];  
  }

  let departmentNames = this.selectedDepartmentEmployeeTrends?.map((dept: any) => dept?.name);
  let bandNames = this.selectedtrendsBands?.map((band: any) => band?.name);

  

  let filteredData = this.currentEmployeeList?.filter((employee: any) =>
    departmentNames?.includes(employee?.department) && bandNames?.includes(employee?.band)
  );
 

  this.employeetrendAccrossyear = filteredData;
  
 console.warn("-----------------bandFilterData--------")
  this.uniqueEmployees = [];

  if (this.selectedtrendsBands.length === 0) {
    return;  
  }

  this.uniqueEmployees = filteredData?.map((emp, index) => ({
    id: index,
    name: emp?.employee
  }));

  this.selectedEmployeeTrends = [];
}




 //employeewise   filter

employeeDropdownSettings = {
  singleSelection: false,
  idField: 'id',
  textField: 'name',
  selectAllText: 'Select All',
  unSelectAllText: 'Unselect All',
  itemsShowLimit: 1,
  allowSearchFilter: true
};


extractBandsAndEmployees(data: any[]) {
  if (data && Array.isArray(data)) {
    this.uniqueBands = Array.from(new Set(data?.map(emp => emp?.band)))?.sort();
    
    this.uniqueBands = Array.isArray(this.uniqueBands) 
  ? this.uniqueBands.map((band, index) => ({
      id: index,
      name: band
    }))
  : [];

  if(this.uniqueBands.length > 0){
    if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
      this.selectedtrendsBands = [this.uniqueBands[0]];
    }
  }

    this.uniqueEmployees = Array.isArray(data)
    ? data.map((emp, index) => ({
        id: index,
        name: emp?.employee
      }))
    : [];
  } else {
    this.uniqueBands = [];
    this.uniqueEmployees = [];
  }

  if(this.uniqueEmployees.length > 0){
    if(this.loggedInUserRole == "Employee" || this.loggedInUserRole == "Manager" || this.loggedInUserRole == "MD"){
      this.selectedEmployeeTrends = [this.uniqueEmployees[0]];
    }
  }

}
 
selectedEmployeeTrends:any=[];

onEmployeeSelect()
{
  this.employeeFilterData();
}

onEmployeeDeSelect(){
  
  this.trendFilterData();
}
onSelectAllEmployees(event:any) 
{
  // this.selectedEmployeeTrends = event;
  this.trendFilterData();
}
onDeSelectAllEmployees()
 { 
  this.selectedEmployeeTrends = [];
  this.trendFilterData();
  }



 employeeFilterData(){
  
  let employeeName = this.selectedEmployeeTrends?.map((employee:any)=>employee.name);
  
  
  if(this.selectedEmployeeTrends.length > 0){
    console.log("if");
    let filteredData = this.currentEmployeeList?.filter((employee:any)=>employeeName?.includes(employee?.employee));
    this.employeetrendAccrossyear = filteredData;
  }else if(this.selectedtrendsBands.length > 0){
    console.log("else if");
    let filteredDataFoeBand = this.selectedtrendsBands?.map((band:any)=>band?.name);
    this.employeetrendAccrossyear = this.currentEmployeeList?.filter((employee:any)=>filteredDataFoeBand?.includes(employee.band));
  }else{
    this.employeetrendAccrossyear = this.currentEmployeeList;
  }


 }




// **************** ENd Employee trends Across Report*********************

// --------------------------------------------------------End Report---------------------------------------------------------------------


  closePositioning(){
    this.isPositioning = false;
    this.isPositioningFormDisabled = false;
  }
  savePositioning(){
    this.isPositioning = false;
    this.isPositioningFormDisabled = false;
  }

  getScoreToFinalConverterIndividual() {

    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }

  saveData() {
    this.onCheckIconView = false;
    this.isFormDisabled = false;
  }




  // transformData(response: any[]): any[] {
  //   return response.map(item => ({
  //     department: item.department,
  //     band: item.band,
  //     firstName: item.firstName,
  //     lastName: item.lastName,
  //     questions: (item.questionnaireDetails || item.questions || []).map((q: any) => ({
  //       questionnaireId: q.questionnaireId,
  //       question: q.question,
  //       weightage: q.weightage
  //     }))
  //   }));
  // }
  

  // get api for the hodscore,finalscore,totalscore
 
  



  // nineboxData1 = [
  //   {
  //     employee: 'Employee 1',
  //     band: 'Low performance low potential',
  //     Wt: 0.3, 
  //     scoreByHod: null, 
  //     finalScore: 18,
  //     questions: [
  //       { id: 1, question: 'What is your key challenge?' ,weightage:30 },
  //       { id: 2, question: 'What support do you need?',weightage:30  },
  //       { id: 3, question: 'How do you plan to improve?',weightage:30  },
  //     ]
  //   },
  //   {
  //     employee: 'Employee 2',
  //     band: 'Medium performance low potential',
  //     Wt: 0.4,
  //     scoreByHod: null,
  //     finalScore: 30, 
  //     questions: [
  //       { id: 1, question: 'What are your short-term goals?What feedback have you received?',weightage:30  },
  //       { id: 2, question: 'What feedback have you received?' ,weightage:30 },
  //       { id: 3, question: 'What training do you need?' ,weightage:30 },
  //       { id: 1, question: 'What are your short-term goals?',weightage:30  },
  //       { id: 2, question: 'What feedback have you received?' ,weightage:30 },
  //       { id: 3, question: 'What training do you need?',weightage:30  },
  //     ]
  //   },
  //   {
  //     employee: 'Employee 3',
  //     band: 'High performer low potential',
  //     Wt: 0.5,
  //     scoreByHod: null,
  //     finalScore: 45, 
  //     questions: [
  //       { id: 1, question: 'How do you maintain consistency?',weightage:30  },
  //       { id: 2, question: 'What motivates you?',weightage:30  },
  //       { id: 3, question: 'What career goals do you have?',weightage:30  },
  //     ]
  //   },

  //   {
  //     employee: 'Employee 2',
  //     band: 'Medium performance low potential',
  //     Wt: 0.4,
  //     scoreByHod: null,
  //     finalScore: 30, 
  //     questions: [
  //       { id: 1, question: 'What are your short-term goals?What feedback have you received?',weightage:30 },
  //       { id: 2, question: 'What feedback have you received?',weightage:30  },
  //       { id: 3, question: 'What training do you need?',weightage:30  },
  //       { id: 1, question: 'What are your short-term goals?' ,weightage:30 },
  //       { id: 2, question: 'What feedback have you received?',weightage:30  },
  //       { id: 3, question: 'What training do you need?' ,weightage:30 },
  //     ]
  //   },
  //   {
  //     employee: 'Employee 3',
  //     band: 'High performer low potential',
  //     Wt: 0.5,
  //     scoreByHod: null,
  //     finalScore: 45, 
  //     questions: [
  //       { id: 1, question: 'How do you maintain consistency?',weightage:30  },
  //       { id: 2, question: 'What motivates you?' ,weightage:30 },
  //       { id: 3, question: 'What career goals do you have?',weightage:30  },
  //     ]
  //   },
  
  // ];

  nineboxReportData = [
    { 
      department: 'sale', 
      employee: 'Employee 1', 
      band: 'Low performance low potential', 
      Wt: 0.3, 
      scoreByHod: 56, 
      totalScore: 33, 
      finalScore: 18, 
      questions: [{ id: 1, question: 'What is your key challenge?' }, { id: 2, question: 'What support do you need?' }, { id: 3, question: 'How do you plan to improve?' }], 
      pmsscore: 12, 
      category: "low potential medium performance" 
    },
    { 
      department: 'finance', 
      employee: 'Employee 2', 
      band: 'Medium performance low potential', 
      Wt: 0.4, 
      scoreByHod: 24, 
      totalScore: 33, 
      finalScore: 30, 
      questions: [{ id: 1, question: 'What are your short-term goals?' }, { id: 2, question: 'What feedback have you received?' }, { id: 3, question: 'What training do you need?' }],
      pmsscore: 12, 
      category: "low potential medium performance" 
    },
    {
      department: 'sale', 
      employee: 'Employee 3', 
      band: 'High performer low potential', 
      Wt: 0.5, 
      scoreByHod: 23, 
      totalScore: 33, 
      finalScore: 45, 
      questions: [{ id: 1, question: 'How do you maintain consistency?' }, { id: 2, question: 'What motivates you?' }, { id: 3, question: 'What career goals do you have?' }],
      pmsscore: 12, 
      category: "low potential medium performance"
    }
  ];
  departments: string[] = [];
  
  // Define the type of groupedData explicitly
  groupedData: { [key: string]: any[] } = {}; 
  filteredData: { [key: string]: any[] } = {};
 

  gridData = [
    { score: '10', description: 'Low performance & high potential', color: 'low', employees: ["Akshay Awari", "Gaurav R."] },
    { score: '06', description: 'Medium performance & high potential', color: 'medium',employees: ["John Doe", "Jane Smith"] },
    { score: '100', description: 'High performance & high potential', color: 'high',employees: ["John Doe", "Jane Smith"] },
    { score: '100', description: 'Low performance & medium potential', color: 'low',employees: ["John Doe", "Jane Smith"] },
    { score: '04', description: 'Medium performance & medium potential', color: 'medium',employees: ["John Doe", "Jane Smith"] },
    { score: '100', description: 'High performance & medium potential', color: 'high',employees: ["John Doe", "Jane Smith"] },
    { score: '100', description: 'Low performance & low potential', color: 'low',employees: ["John Doe", "Jane Smith"] },
    { score: '01', description: 'Medium performance & low potential', color: 'medium',employees: ["John Doe", "Jane Smith"] },
    { score: '01', description: 'High performance & low potential', color: 'high',employees: ["John Doe", "Jane Smith"] },
  ];
  

  showEmployeeList(event: MouseEvent, employees: string[]) {
    this.hoveredEmployees = employees;
    this.popupStyle = {
      top: `${event?.clientY + 10}px`,
      left: `${event?.clientX + 10}px`
    };
  }

  hideEmployeeList() {
    this.hoveredEmployees = [];
  }

 
  downloadNineBoxPDF(type: any,idSelectorType:any): void {


    const currentDate = new Date();
    const todayDate = `${currentDate?.getFullYear()}-${(currentDate?.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate?.getDate()?.toString()?.padStart(2, '0')}`;
  
     
      var idSelector = idSelectorType;
  
   
    //Call the common function from the service
    this.PdfDownload?.downloadPDF(
      idSelector, // chartId
      type, // Title
      "", // Year
      "", // From Date
      "",
    );
  } 
  



  downloadCSV() {

    const header = ["Band", "Employee", "Questions", "Wt(%)", "Score By HOD", "Total Score", "Final Score"];
    const csvRows = [header]; // Initialize with headers

    this.nineboxData?.forEach((employee: any) => {
        employee?.questions?.forEach((q: any, index: number) => {
            csvRows?.push([
                index === 0 ? employee?.band : "", 
                index === 0 ? `${employee?.firstName} ${employee?.lastName}` : "", 
                q?.question,
                q?.weightage,
                q?.hodScore,
                q?.totalScore,
                index === employee?.questions?.length - 1 ? employee?.finalScore : "" 
            ]);
        });
    });

    let csvContent = "data:text/csv;charset=utf-8," + csvRows?.map(row => row.join(","))?.join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document?.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "nineBoxMaster.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}



downloaDumpReport() {
  const header = ["Band", "Employee", "Department","Questions", "Wt(%)", "Score By HOD", "Total Score", "Final Score", "PMS Score", "Category"];
  const csvRows = [header];

  if (!this.groupedData || typeof this.groupedData !== 'object') {
    console.error("Error: groupedData is not an object", this.groupedData);
    return;
  }

  // Convert groupedData (object) into a single array of employees
  const employeesArray = Object?.values(this.groupedData)?.reduce((acc, val) => acc?.concat(val), []);

  if (!Array.isArray(employeesArray) || employeesArray?.length === 0) {
    console.error("Error: employeesArray is not an array or is empty", employeesArray);
    return;
  }

  employeesArray?.forEach((employee: any) => {
    if (!Array.isArray(employee?.questions)) {
      console.error("Error: employee.questions is not an array", employee);
      return;
    }

    employee?.questions?.forEach((q: any, index: number) => {
      csvRows?.push([
        index === 0 ? employee?.department : "",
        index === 0 ? employee?.band : "",
        index === 0 ? `${employee?.firstName} ${employee?.lastName}` : "",
        q?.question,
        q?.weightage,
        q?.hodScore,
        q?.totalScore,
        index === employee?.questions.length - 1 ? employee?.finalScore : "",
        index === employee?.questions.length - 1 ? employee?.kpiScore : "",
        index === employee?.questions.length - 1 ? employee?.category : "",
      ]);
    });
  });

  let csvContent = "data:text/csv;charset=utf-8," + csvRows?.map(row => row?.join(","))?.join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "dumpReport.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

downloadTrendReport() {
  const header = [
    "Year", 
    "Employee", 
    "Band", 
    "Department", 
    "Potential Score", 
    "Performance Score", 
    "9 Box Category"
  ];
  const csvRows = [header]; 

  this.employeetrendAccrossyear?.forEach((employee: any) => {
    employee?.trends?.forEach((trend: any) => {
      csvRows.push([
        trend?.year,
        employee?.employee, 
        employee?.band,
        employee?.department,
        trend?.totalScore,
        trend?.kpiScore,
        trend?.category
      ]);
    });
  });

  let csvContent = "data:text/csv;charset=utf-8," + csvRows.map(row => row.join(",")).join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", "nineBoxTrendsReports.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}




// ==========================Search Filter============================== 


filteredNineBox: any[] = [];
  searchTerm: string = '';


  filterNineBoxMaster(searchTerm: string) {
     if (!searchTerm.trim()) {
      this.NineBoxMasterDepartmentChange(this.selectDepartname);
      return;
    }
  
    const normalizedSearchTerm = searchTerm?.trim()?.toLowerCase();

    const filterBySearchTerm = (searchKey: any[]) =>
      searchKey?.filter((ninebox: any) => {
        const fullName = `${(ninebox?.firstName ?? '')?.trim()} ${(ninebox?.lastName ?? '')?.trim()}`?.trim()?.toLowerCase();

      
        const matchesQuestionData = ninebox?.questions?.some((q: any) => 
          q?.question?.toString()?.toLowerCase()?.includes(normalizedSearchTerm) ||
          (q?.weightage != null && q.weightage.toString().includes(normalizedSearchTerm)) ||
          (q?.hodScore != null && q.hodScore.toString().includes(normalizedSearchTerm)) ||
          (q?.totalScore != null && q.totalScore.toString().includes(normalizedSearchTerm))
        );
    
        return (
          fullName?.includes(normalizedSearchTerm) ||
          (ninebox?.band?.toString()?.toLowerCase()?.includes(normalizedSearchTerm)) ||
          (ninebox?.finalScore != null && ninebox?.finalScore?.toString()?.includes(normalizedSearchTerm)) ||
          matchesQuestionData
        );
      });
    
    this.filteredNineBox = filterBySearchTerm(this.nineboxData);
    this.nineboxData = [...this.filteredNineBox];
  }

 
  private resetNineBoxData() {
    this.nineboxData = [...this.arrNineBoxMasterData];
  }









// Search filter for trends


searchDumpReport: string = '';


filterDumpReport(searchDumpReport: string) {


  if (!searchDumpReport.trim()) {
    
    this.getDashBoardDeptWise();
    return;
  }

  // Normalize the search term
  const normalizedSearchTerm = searchDumpReport?.trim()?.toLowerCase();

  const filterBySearchTerm = (data: any[]) =>
    data?.filter((employee: any) => {
      const fullName = `${(employee?.firstName ?? '')?.trim()} ${(employee?.lastName ?? '')?.trim()}`?.trim()?.toLowerCase();

      const matchesQuestionData = employee?.questions?.some((q: any) => 
        q?.question?.toString().toLowerCase().includes(normalizedSearchTerm) ||
        (q?.weightage != null && q?.weightage?.toString()?.includes(normalizedSearchTerm)) ||
        (q?.hodScore != null && q?.hodScore?.toString()?.includes(normalizedSearchTerm)) ||
        (q?.totalScore != null && q?.totalScore?.toString()?.includes(normalizedSearchTerm))
      );

      return (
        fullName.includes(normalizedSearchTerm) ||
        (employee?.band?.toString()?.toLowerCase()?.includes(normalizedSearchTerm)) ||
        (employee?.department?.toString()?.toLowerCase()?.includes(normalizedSearchTerm)) ||
        (employee?.category?.toString().toLowerCase()?.includes(normalizedSearchTerm)) ||
        (employee?.finalScore != null && employee?.finalScore?.toString()?.includes(normalizedSearchTerm)) ||
        (employee?.kpiScore != null && employee?.kpiScore?.toString()?.includes(normalizedSearchTerm)) ||
        matchesQuestionData
      );
    });

 
  let filteredData: any = {};

  Object?.entries(this.groupedData)?.forEach(([department, employees]: any) => {
    const filteredEmployees = filterBySearchTerm(employees);
    if (filteredEmployees?.length > 0) {
      filteredData[department] = filteredEmployees;
    }
  });


  this.groupedData = filteredData;
  // this.departments = Object.keys(this.groupedData);
}

private resetDumpReport() {
  this.groupedData = { ...this.arrDumpReport };

  this.departments = Object?.keys(this.groupedData);
}



  }

